/**
 * Português do Brasil.
 *
 * Chave ausente cai no inglês — ver `i18n/index.js`. Isso permite traduzir em
 * fatias sem deixar buraco na tela.
 *
 * Sobre a moeda: os preços continuam em dólar. Interface em português com preço
 * em dólar é a combinação certa aqui — trocar a moeda junto do idioma criaria
 * uma tabela de preços que ninguém definiu.
 */
const pt = {
  comum: {
    salvar: 'Salvar alterações',
    salvando: 'Salvando…',
    cancelar: 'Cancelar',
    fechar: 'Fechar',
    pularConteudo: 'Pular para o conteúdo',
    carregando: 'Carregando…',
    soGestor: 'Só um gestor da empresa pode mexer aqui.',
    voltar: 'Voltar',
    buscar: 'Buscar',
    todos: 'Todos',
    ordenarPor: 'Ordenar por',
    ordemPadrao: 'Ordem padrão',
    crescente: 'crescente',
    decrescente: 'decrescente'
  },

  menu: {
    visaoGeral: 'Visão geral',
    painel: 'Painel',
    projetos: 'Projetos',
    meusProjetos: 'Meus projetos',
    criarProjeto: 'Criar projeto',
    conta: 'Conta',
    perfil: 'Meu perfil',
    pagamentos: 'Pagamentos',
    planoEUso: 'Plano e uso',
    legal: 'Jurídico',
    privacidade: 'Política de Privacidade',
    termos: 'Termos de Serviço',
    sair: 'Sair',
    creditosSufixo: '/{total} créditos de IA',
    faturamento: 'Faturamento',
    configuracoes: 'Configurações',
    planos: 'Planos',
    execucoes: 'Execuções',
    ajuda: 'Ajuda',
    documentacao: 'Documentação',
    creditos: '{restantes}/{total} créditos de IA'
  },

  conta: {
    titulo: 'Conta',
    plano: 'Plano {plano}',
    verPlanos: 'Ver todos os planos',

    perfil: 'Perfil',
    nome: 'Nome',
    email: 'E-mail',
    trocarFoto: 'Trocar',
    enviandoFoto: 'Enviando…',
    perfilSalvo: 'Perfil atualizado.',
    fotoSalva: 'Foto de perfil atualizada.',

    empresaTexto: 'Os dados cadastrais da empresa. Só um gestor pode alterá-los.',
    freelancerTexto:
      'Sua conta é de uma pessoa só: plano, créditos de IA e projetos são só seus. Para transformá-la em empresa, preencha os dados. Plano, créditos e projetos continuam como estão, e não dá para voltar a freelancer.',
    soGestor: 'Só um gestor pode alterar os dados da empresa.',
    converter: 'Converter em empresa',
    confirmarConversao: 'Converter esta conta em empresa? Não dá para voltar a freelancer.',
    convertida: 'Sua conta agora é uma empresa.',
    empresaSalva: 'Dados da empresa atualizados.',

    idioma: 'Idioma',
    idiomaAjuda: 'Vale para a interface e para a análise de IA. Os preços continuam em dólar.',
    idiomaSalvo: 'Idioma atualizado.',

    uso: 'Uso',
    projetos: 'Projetos',
    paginasEVideos: 'Páginas e vídeos',
    detalhePaginas: '{sites} páginas de site · {youtube} vídeos do YouTube',
    melhorarPara: 'Mudar para {plano}',
    falarConosco: 'Fale com a gente',

    creditos: 'Créditos de IA',
    restantesNoMes: 'restantes neste mês',
    esteMes: '{n} deste mês',
    comprados: '{n} comprados',
    comprarChamada: 'Precisa de mais este mês? Crédito comprado não expira — fica até você usar.',
    comprarPacote: 'Comprar {n} créditos',
    abrindo: 'Abrindo…',
    pagamentoRecebido: 'Pagamento recebido. Seus créditos aparecem em instantes.',
    reiniciaEm: 'Renova em {data}',
    tokensPorAnalise: '{n} tokens por análise',

    conector: 'Conector para IA',
    conectorIntro:
      'Por padrão, a IA conectada só lê os seus dados. Aqui você pode permitir que ela também solicite rastreamentos.',
    conectorEscrita: 'Permitir que a IA conectada solicite rastreamentos',
    conectorNotaCota:
      'Cada rastreamento consome a cota de páginas do seu plano, e isso não é reversível.',
    conectorNotaLimite:
      'Há um teto de rastreamentos por dia por essa via, e um de cada vez por projeto. Pela tela do Silent Puma não há esse limite.',
    conectorNotaEscopo:
      'Nada além disso muda: a IA continua sem poder criar projetos, apagar execuções, gerar análises ou alterar a sua conta.',
    conectorReconectar:
      'Remova e adicione o conector de novo na sua IA para a mudança valer — ela guarda a lista de ferramentas de quando você conectou.',
    zonaDeRisco: 'Zona de risco',
    riscoBasic:
      'Apagar a conta remove todos os projetos, execuções e análises. Não há como desfazer.',
    riscoPago:
      'Cancelar mantém o plano até o fim do período já pago. Apagar a conta remove tudo na hora, sem como desfazer.',
    riscoAnalista: 'Apagar a sua conta tira só você da empresa: projetos e execuções ficam com a equipe.',
    confirmarSaida: 'Apagar a sua conta e sair da empresa? Isso não pode ser desfeito.',
    cancelarAssinatura: 'Cancelar assinatura',
    assinaturaEncerra: 'A assinatura termina no fim do período atual.',
    apagarConta: 'Apagar conta',
    confirmarCancelamento:
      'A assinatura continua valendo até o fim do período já pago, e depois passa para o Basic. Continuar?',
    confirmarExclusao: 'Apagar sua conta e tudo o que há nela? Isso não pode ser desfeito.',
    contaApagada: 'Sua conta foi apagada em definitivo.',

    business: 'Plano Business',
    businessChamada: 'Conte o que você precisa e preparamos uma proposta.',
    empresa: 'Empresa',
    mensagem: 'Mensagem',
    enviarMensagem: 'Enviar mensagem',
    enviando: 'Enviando…',
    mensagemEnviada: 'Mensagem enviada. Respondemos em breve.'
  },

  equipe: {
    titulo: 'Equipe',
    texto: 'Quem entra pela equipe usa os mesmos projetos, a mesma cota e os mesmos créditos da empresa.',
    textoAnalista: 'Só um gestor convida pessoas e cancela convites.',
    textoFreelancer: 'Equipes são de empresas. Converta a conta em empresa na aba Empresa para convidar pessoas.',
    textoBasic: 'Convidar pessoas começa no plano Guru.',
    gestor: 'Gestor',
    analista: 'Analista',
    papel: 'Papel',
    pendente: 'Convite pendente, vale até {data}',
    expirado: 'Convite expirado. Convide de novo para mandar outro link.',
    cancelar: 'Cancelar convite',
    confirmarCancelamento: 'Cancelar o convite para {email}? O link deixa de funcionar.',
    cancelado: 'Convite cancelado.',
    convidarTitulo: 'Convidar',
    convidarTexto:
      'O convite vai por e-mail e vale por 7 dias. O analista trabalha nos projetos; o gestor também cuida do plano, dos pagamentos, das integrações e da equipe.',
    enviar: 'Enviar convite',
    enviando: 'Enviando…',
    enviado: 'Convite enviado. O link vale por 7 dias.',
    conviteTitulo: 'Convite para a equipe',
    chamada: 'A sua equipe já está no Silent Puma.',
    aceitarTitulo: 'Entrar na {organizacao}',
    aceitarTexto: 'O convite é para entrar como {papel}. Crie o seu acesso.',
    aceitar: 'Aceitar e entrar',
    aceitando: 'Entrando…',
    voce: '(você)',
    papelDe: 'Papel de {nome}',
    papelMudado: 'Papel alterado.',
    remover: 'Remover',
    confirmarRemocao: 'Remover {nome} da equipe? A conta dessa pessoa é apagada; projetos e execuções ficam com a empresa.',
    removido: 'Pessoa removida da equipe.'
  },
  painel: {
    ola: 'Bem-vindo de volta, {nome}!',
    chamada: 'Vamos melhorar seu SEO hoje.',
    projetos: 'Projetos',
    paginasNoMes: 'Páginas neste mês',
    creditos: 'Créditos de IA',
    ilimitado: 'ilimitado',
    execucoesRecentes: 'Execuções recentes',
    verProjetos: 'Ver projetos',
    semExecucoes: 'Nenhuma execução ainda.',
    criarProjeto: 'Criar um projeto',
    paraComecar: 'para começar.',
    atalhoComecar: 'Primeiros passos',
    atalhoComecarTexto: 'Crie seu primeiro projeto e rode a primeira análise.',
    atalhoComecarCta: 'Criar projeto',
    atalhoAnalise: 'Rodar análise',
    atalhoAnaliseTexto: 'Inicie uma execução num projeto que você já tem.',
    atalhoAnaliseCta: 'Ver projetos',
    atalhoPlano: 'Plano e uso',
    atalhoPlanoTexto: 'Páginas, créditos de IA e o que seu plano ainda cobre.',
    atalhoPlanoCta: 'Ver uso'
  },

  execucao: {
    coluna: 'Execução',
    projeto: 'Projeto',
    paginas: 'Páginas',
    videos: 'Vídeos',
    status: 'Status',
    iniciada: 'Início',
    acoes: 'Ações',
    limite: 'limite',
    concluida: 'Concluída',
    emAndamento: 'Em andamento',
    naFila: 'Na fila',
    falhou: 'Falhou',
    cancelada: 'Cancelada',
    verAnalise: 'Ver análise',
    otimizacoes: 'Otimizações de IA',
    relatorio: 'Relatório',
    detalhes: 'Detalhes',
    repetir: 'Repetir',
    repetindo: 'Iniciando…',
    repetirAjuda: 'Rastreia as mesmas páginas de novo, para comparar',
    mesmasPaginas: 'Mesmas páginas da execução #{n}',
    novaExecucao: '+ Nova execução',
    buscar: 'Buscar execuções...',
    filtrar: 'Filtrar por status',
    total: { um: '{n} execução', outros: '{n} execuções' },
    retencao: 'retenção de {n} dias',
    semExpiracao: 'sem expiração de dados',
    vazio: 'Este projeto ainda não tem execuções.',
    semFiltro: 'Nenhuma execução corresponde ao filtro.',
    primeira: 'Iniciar a primeira execução',
    confirmarExclusao: 'Tem certeza de que quer apagar esta execução?',
    parar: 'Parar',
    confirmarParada: 'Parar esta execução agora? As páginas já coletadas ficam salvas, mas ela não recebe nota.',
    apagar: 'Apagar execução {n}'
  },

  projeto: {
    titulo: 'Meus projetos',
    total: { um: '{n} projeto no total', outros: '{n} projetos no total' },
    vagas: '{usados} de {limite} vagas no plano {plano}',
    buscar: 'Buscar projetos...',
    filtrar: 'Filtrar por tipo',
    site: 'Site',
    youtube: 'YouTube',
    paginas: 'páginas',
    videos: 'vídeos',
    execucoes: 'execuções',
    ultimaExecucao: 'última execução',
    verExecucoes: 'Ver execuções',
    baixarCsv: 'Baixar CSV',
    painel: 'Painel',
    novo: 'Novo projeto',
    primeiro: 'Crie seu primeiro projeto',
    tipoDeProjeto: 'Site ou canal do YouTube.',
    vagasLivres: {
      um: '{n} vaga livre no plano {plano}.',
      outros: '{n} vagas livres no plano {plano}.'
    },
    criar: '+ Criar projeto',
    confirmarExclusao: 'Tem certeza de que quer apagar este projeto?',
    apagar: 'Apagar {nome}',
    integracoesDe: 'Integrações de {nome}',
    integracoesChamada: 'Conecte dados do Google para enriquecer as análises deste projeto.',
    soNoPro: 'Disponível no Pro',
    soNoProTexto:
      'As integrações com Google Analytics, Search Console e YouTube Analytics fazem parte dos planos Pro e Business.',
    verPlanos: 'Ver planos',
    hoje: 'hoje',
    ontem: 'ontem',
    diasAtras: 'há {n}d',
    mesesAtras: 'há {n}m',
    anosAtras: 'há {n}a'
  },

  paginacao: { anterior: 'Anterior', proxima: 'Próxima' },

  site: {
    idioma: 'Idioma',
    recursos: 'Recursos',
    precos: 'Preços',
    blog: 'Blog',
    contato: 'Contato',
    abrirMenu: 'Abrir menu',
    entrar: 'Entrar',
    experimentar: 'Experimentar',
    produto: 'Produto',
    empresa: 'Empresa',
    legal: 'Jurídico',
    privacidade: 'Política de Privacidade',
    termos: 'Termos de Serviço',
    direitos: '© {ano} Silent Puma. Todos os direitos reservados.'
  },

  /* Title e description das páginas públicas — ver src/config/seo.js. */
  seo: {
    homeTitulo: 'Silent Puma — auditoria de SEO para sites e YouTube',
    homeDescricao:
      'Rastreie seu site, veja o que está quebrado em ordem de impacto e receba sugestões de IA. Auditoria de SEO para sites e YouTube, grátis até 3.000 páginas/mês.',
    blogTitulo: 'Blog: o que medimos e o que os números dizem',
    blogDescricao:
      'Notas técnicas sobre auditoria de SEO de quem roda crawlers todo dia. Cada post traz o método, para você conferir em vez de acreditar.',
    planosTitulo: 'Planos e preços: comece grátis',
    planosDescricao:
      'Compare os planos do Silent Puma. O Basic é grátis: 1 projeto, 3.000 páginas por mês, sem cartão. Os pagos somam projetos, páginas, retenção e créditos de IA.',
    privacidadeTitulo: 'Política de Privacidade: o que coletamos',
    privacidadeDescricao:
      'O que o Silent Puma coleta, o que o crawler coleta, como a análise de IA e as integrações com o Google usam seus dados, por quanto tempo ficam e seus direitos.',
    termosTitulo: 'Termos de Serviço',
    termosDescricao:
      'Os termos de uso do Silent Puma: sua conta, o que você pode rastrear, planos, limites e créditos, pagamento e cancelamento, recomendações de IA e retenção.',
    entrarTitulo: 'Entrar no seu painel de SEO',
    entrarDescricao:
      'Entre no Silent Puma para ver seus projetos, execuções de rastreio, scores de SEO e recomendações de IA para seus sites e canais do YouTube.',
    cadastroTitulo: 'Crie sua conta grátis',
    cadastroDescricao:
      'Crie uma conta grátis no Silent Puma: 1 projeto e 3.000 páginas por mês, exportação em CSV desde o primeiro dia e sem cartão. Mude de plano só quando precisar.'
  },

  concluir: {
    titulo: 'Conclua seu cadastro',
    texto: 'O Stripe confirmou o seu plano. Agora defina a senha com que você vai entrar.',
    textoGoogle: 'O Stripe confirmou o seu plano. A conta fica ligada ao Google: você entra pelo botão do Google, sem senha.',
    conferindo: 'Conferindo a confirmação do Stripe…',
    regrasTitulo: 'A senha precisa ter:',
    atendida: 'atendida',
    contaExiste: 'Esta conta já foi criada.',
    formato: 'Como você vai usar o Silent Puma?',
    freelancer: 'Freelancer',
    empresa: 'Empresa',
    equipeNasConfiguracoes: 'Depois do cadastro, convide a equipe em Configurações, a partir do plano Guru.',
    nomeDaEmpresa: 'Nome da empresa',
    funcionarios: 'Número de funcionários',
    tipoEmpresa: 'Tipo de empresa',
    selecione: 'Selecione',
    ate10: 'Até 10',
    de11a50: '11 a 50',
    de51a200: '51 a 200',
    de201a1000: '201 a 1.000',
    maisDe1000: 'Mais de 1.000',
    agencia: 'Agência, que atende clientes',
    padrao: 'Empresa, que cuida da própria marca',
    faltaFormato: 'Escolha como você vai usar o Silent Puma.',
    faltaEmpresa: 'Preencha o nome, o número de funcionários e o tipo da empresa.'
  },

  juridico: {
    nestaPagina: 'Nesta página',
    emResumo: 'Em resumo',
    traducao: 'Tradução do texto em inglês, que vale se as duas versões divergirem.',
    lerEmIngles: 'Read in English',
    leiaTambem: 'Leia também:',
    copiarSecao: 'Copiar link desta seção'
  },

  /* Aviso de cookies — components/AvisoDeCookies.js. */
  cookies: {
    titulo: 'Cookies',
    texto: 'Se você permitir, usamos o Google Analytics para saber quais páginas são visitadas. Sem a sua permissão, nada é enviado ao Google.',
    saibaMais: 'Saiba mais',
    aceitar: 'Aceitar',
    recusar: 'Recusar'
  },

  naoEncontrada: {
    titulo: 'Página não encontrada',
    ajuda: 'A página que você procura não existe ou foi movida.',
    paraPainel: 'Ir para o meu painel',
    paraHome: 'Voltar para a home',
    meusProjetos: 'Meus projetos'
  },

  acesso: {
    provaRetencao: 'Nenhum dado de crawl é apagado antes da retenção do seu plano.',
    runFeita: 'concluída',
    runRodando: 'rodando',
    runFalhou: 'falhou',
    pontoBasico: '1 projeto e 3.000 páginas por mês',
    pontoBasicoSub: 'Sem cartão de crédito, sem prazo de validade.',
    pontoCsv: 'Exportação em CSV desde o primeiro dia',
    pontoCsvSub: 'Os dados são seus, em todos os planos.',
    pontoRetencao: 'Retenção de 7 dias no Basic',
    pontoRetencaoSub: '30 dias no Guru, 90 no Pro, ilimitado no Business.',
    pontoUpgrade: 'Mude de plano sem perder o histórico',
    pontoUpgradeSub: 'As execuções antigas continuam disponíveis.',

    email: 'E-mail',
    senha: 'Senha',
    mostrar: 'Mostrar',
    esconder: 'Esconder',
    ou: 'OU',
    comGoogle: 'Continuar com o Google',
    continuar: 'Continuar',

    chamadaLogin: 'Seus projetos e execuções estão onde você parou.',
    entrar: 'Entrar',
    entrarTexto: 'Entre para ver seus projetos e execuções.',
    entrando: 'Entrando…',
    semConta: 'Ainda não tem conta?',
    criarConta: 'Criar conta',
    esqueceu: 'Esqueceu a senha?',

    chamadaCadastro: 'Comece no plano gratuito, sem cartão.',
    criarTitulo: 'Crie sua conta',
    criarTexto: '1 projeto e 3.000 páginas por mês, de graça.',
    nomeCompleto: 'Nome completo',
    senhaDepois: 'Você escolhe a senha no próximo passo, depois de confirmar o plano.',
    criando: 'Criando…',
    criarBotao: 'Criar conta',
    jaTemConta: 'Já tem conta?',
    consentimentoA: 'Ao criar uma conta você concorda com os nossos',
    consentimentoE: 'e com a nossa',

    chamadaEsqueci: 'De volta, num e-mail só.',
    esqueciTitulo: 'Esqueceu a senha?',
    esqueciTexto: 'Informe o e-mail da sua conta e enviamos um link para redefinir.',
    enviando: 'Enviando…',
    enviarLink: 'Enviar link',
    linkEnviado: 'Se este e-mail estiver cadastrado, o link para redefinir já está a caminho.',
    lembrou: 'Lembrou a senha?',

    chamadaNovaSenha: 'Defina uma senha nova e continue de onde parou.',
    novaSenhaTitulo: 'Nova senha',
    minimoDeCaracteres: 'Pelo menos {n} caracteres.',
    novaSenha: 'Nova senha',
    confirmarSenha: 'Confirmar senha',
    salvando: 'Salvando…',
    atualizarSenha: 'Atualizar senha',
    senhaAtualizada: 'Senha atualizada. Levando você para a entrada…',
    voltarAoLogin: 'Voltar para a entrada',
    senhasDiferentes: 'As senhas não coincidem.',
    senhaCurta: 'A senha precisa ter pelo menos {n} caracteres.',

    chamadaConcluir: 'Falta um passo — e então o seu primeiro crawl.',
    concluirTitulo: 'Conclua sua conta',
    concluirTexto: 'Pagamento confirmado. Defina como você vai entrar.',
    seuNome: 'Seu nome',
    seuEmail: 'Seu e-mail',
    escolhaSenha: 'Escolha uma senha',
    regrasAtendidas: '{n} de {total} regras de senha atendidas',
    aindaFalta: 'Ainda falta {itens}.',
    senhaPrecisa: 'A senha precisa de {itens}.',
    contaGoogle: 'Conta vinculada ao Google — entre pelo botão do Google, sem senha.',
    concluindo: 'Concluindo…',
    concluirBotao: 'Concluir cadastro',
    regraTamanho: 'pelo menos 8 caracteres',
    regraMaiuscula: 'uma letra maiúscula',
    regraMinuscula: 'uma letra minúscula',
    regraNumero: 'um número',
    regraEspecial: 'um caractere especial (!@#$%^&*)',

    autenticando: 'Autenticando…'
  },

  entrada: {
    titulo: 'Entrar no Silent Puma',
    texto: 'Seus projetos e execuções estão onde você parou.',
    comGoogle: 'Continuar com o Google',
    abrindoGoogle: 'Abrindo o Google…',
    ouEmail: 'ou com e-mail e senha',
    email: 'E-mail',
    senha: 'Senha',
    esqueceu: 'Esqueceu a senha?',
    mostrar: 'Mostrar',
    esconder: 'Esconder',
    botao: 'Entrar',
    entrando: 'Entrando…',
    faltaEmail: 'Informe o e-mail da sua conta, no formato nome@empresa.com.',
    faltaSenha: 'Informe a senha. Se a conta foi criada com o Google, use o botão do Google acima.',
    erroDados: 'E-mail ou senha não conferem. Se a conta foi criada com o Google, use o botão do Google acima.',
    erroMuitas: 'Muitas tentativas seguidas. Espere alguns minutos e tente de novo.',
    erroRede: 'Não conseguimos falar com o servidor. Confira sua conexão e tente de novo.',
    erroGoogle: 'A entrada pelo Google não foi concluída. Tente de novo ou entre com e-mail e senha.',
    semConta: 'Ainda não tem conta?',
    criarConta: 'Criar conta grátis',
    novoNoBlog: 'Novo no blog: {titulo}',
    fotoAlt: 'Puma caminhando à noite em direção à câmera, fotografado por uma armadilha fotográfica.',
    fotoCredito: 'Foto: National Park Service, domínio público'
  },

  recuperar: {
    titulo: 'Recuperar a senha',
    texto: 'Informe o e-mail da sua conta e mandamos um link para você definir uma senha nova.',
    botao: 'Enviar o link',
    enviando: 'Enviando…',
    enviado: 'Se houver uma conta com {email}, o link já está a caminho.',
    validade: 'Ele vale por 1 hora e funciona uma vez só. Se não chegar em alguns minutos, confira a caixa de spam.',
    deNovo: 'Mandar de novo',
    lembrou: 'Lembrou a senha?',
    entrar: 'Entrar'
  },

  cadastro: {
    titulo: 'Crie sua conta no Silent Puma',
    texto: '{projetos} e {paginas} páginas por mês no plano Basic, grátis e sem cartão.',
    projetos: { um: '{n} projeto', outros: '{n} projetos' },
    ouEmail: 'ou com nome e e-mail',
    nome: 'Nome',
    depois: 'Em seguida, o Stripe confirma o plano Basic sem pedir cartão, e você volta ao Silent Puma para definir a senha.',
    botao: 'Criar conta grátis',
    abrindoStripe: 'Abrindo o Stripe…',
    consentimentoA: 'Ao criar a conta, com o Google ou com e-mail, você concorda com os',
    consentimentoE: 'e com a',
    jaTemConta: 'Já tem conta?',
    entrar: 'Entrar',
    faltaNome: 'Informe seu nome.',
    faltaEmail: 'Informe um e-mail no formato nome@empresa.com.',
    emailExiste: 'Esse e-mail já tem conta.',
    irEntrar: 'Entre com ele',
    ou: 'ou',
    irSenha: 'recupere a senha',
    erroCheckout: 'Não conseguimos abrir o Stripe agora. Tente de novo em alguns instantes.',
    semContaGoogle: 'Essa conta do Google ainda não tem cadastro no Silent Puma. Crie a sua aqui.',
    planoTitulo: 'O que vem no plano Basic',
    planoProjetos: 'Projetos',
    planoPaginas: 'Páginas por mês',
    planoHistorico: 'Histórico das execuções',
    planoDias: { um: '{n} dia', outros: '{n} dias' },
    planoCreditos: 'Créditos de IA por mês',
    planoPreco: 'Preço',
    planoGratis: 'Grátis, sem cartão'
  },

  notas: {
    titulo: 'O que os números querem dizer',
    chamada:
      'Notas técnicas de quem roda crawler todo dia. Cada post traz o método, para você conferir em vez de acreditar.',
    minutos: { um: '{n} min de leitura', outros: '{n} min de leitura' },
    lerPost: 'Ler o post',
    anteriores: 'Posts anteriores',
    semPosts: 'Nada publicado ainda. As primeiras notas estão sendo escritas.',
    figuraTitulo: 'Os cinco pesos da nota, em pontos',
    figuraRotulo: 'Os cinco pesos da nota, em pontos: {lista}.',
    figuraLegenda: 'A altura de cada barra é o quanto a área vale. Somadas, dão os 100 pontos de onde a nota parte.',
    trilha: 'Trilha',
    nestePost: 'Neste post',
    compartilhar: 'Compartilhar',
    copiarLink: 'Copiar link',
    linkCopiado: 'Link copiado',
    naoCopiou: 'Não deu para copiar. Copie o endereço pela barra do navegador.',
    legendaTela: 'A capa de uma execução de exemplo. A altura de cada barra é o peso da área; o topo vazio é o que ela perdeu.',
    calcTitulo: 'Faça a conta',
    calcTexto: 'Diga quantas páginas cada área afeta e veja a nota sair da mesma função que o produto usa.',
    calcPaginas: 'Páginas rastreadas',
    calcSemNota: 'Sem páginas, sem nota',
    leiaTambem: 'Leia também',
    fimBlog: 'Veja a conta do seu site',
    fimPost: 'Veja essa conta no seu site',
    fimBotao: 'Rastrear meu site grátis',
    fimNota: '{paginas} páginas por mês no plano Basic, sem cartão.'
  },

  home: {
    selo: 'Análise de SEO com IA',
    tituloA: 'Descubra o ',
    tituloEm: 'potencial escondido',
    chamada:
      'O Silent Puma é seu parceiro de SEO com IA. Ele rastreia seu site, ordena o que está quebrado e entrega a lista que o seu cliente vai perguntar.',
    comecarGratis: 'Começar de graça',
    semCartao: 'Sem cartão no plano Basic',
    paginasGratis: '3.000 páginas/mês de graça',

    sinaisPorPagina: 'Sinais por página',
    secoesDeAnalise: 'Seções de análise',
    siteEYoutube: 'Site e YouTube',

    demoPaginas: 'páginas',
    demoScore: 'score',
    demoCriticas: 'críticas',
    demoRodando: 'rastreando',
    demoProgresso: 'PROGRESSO',
    demoTituloLongo: 'título com 71 car.',
    demoSemMeta: 'sem meta desc.',
    demoOk: 'ok',
    demoLinksQuebrados: '3 links quebrados',

    recursosEyebrow: 'Recursos',
    recursosTituloA: 'Recursos poderosos para ',
    recursosTituloEm: 'um SEO melhor',
    recursosChamada:
      'Veja como o Silent Puma transforma o desempenho do seu site com um conjunto completo de ferramentas.',
    rapidoTitulo: 'Análise rápida',
    rapidoMeta: 'CRAWLER EM RUST · RENDERIZAÇÃO HEADLESS',
    rapidoTexto:
      'Analise seu site com velocidade e precisão fora do comum. Tenha respostas acionáveis em tempo recorde com nosso motor de rastreamento.',
    exportarTitulo: 'Exportação de dados',
    exportarMeta: 'CSV · EM FLUXO, EM QUALQUER TAMANHO',
    exportarTexto:
      'Exporte os resultados sem esforço em vários formatos. Compartilhe com seu time ou com seus clientes em CSV, Excel ou Google Sheets.',
    graficosTitulo: 'Gráficos interativos',
    graficosMeta: 'FILTRE POR EXECUÇÃO, URL E STATUS',
    graficosTexto:
      'Visualize seus dados em gráficos interativos. Identifique tendências e oportunidades com ferramentas de visualização diretas.',
    iaTitulo: 'Otimizações de IA',
    iaMeta: 'PRIORIZADAS POR IMPACTO',
    iaTexto:
      'A IA lê o seu crawl e devolve uma lista priorizada de correções, cada uma mostrando quantas páginas ela afeta. Análise padrão ou profunda, com os seus créditos.',

    contatoTitulo: 'Fale com a gente',
    contatoChamada:
      'Tem dúvidas? A gente quer ouvir você. Mande uma mensagem e respondemos o quanto antes.',
    respostaEmUmDia: 'RESPOSTA EM ATÉ 1 DIA ÚTIL',
    chatAoVivo: 'Chat ao vivo',
    chatPlanos: 'PLANOS GURU E PRO',
    conectorMcp: 'Conector MCP',
    conectorPlanos: 'PLANOS GURU, PRO E BUSINESS',
    seuNome: 'Seu nome',
    seuEmail: 'Seu e-mail',
    suaMensagem: 'Sua mensagem',
    nomePlaceholder: 'Seu nome',
    emailPlaceholder: 'voce@empresa.com',
    mensagemPlaceholder: 'Quero acompanhar 4 domínios de clientes todo mês.',
    enviando: 'Enviando…',
    enviarMensagem: 'Enviar mensagem',
    mensagemEnviada: 'Mensagem enviada. Respondemos em até um dia útil.',
    mensagemFalhou: 'Não conseguimos enviar. Tente de novo em um minuto.'
  },

  /* Página inicial nova (pages/NewHome.js). Convive com `home`, que é da
     página antiga: quando a antiga for apagada, `home` sai junto. */
  inicio: {
    palco: {
      titulo: 'Auditoria de SEO que se explica',
      chamada:
        'Rastreamos cada página do seu site ou canal do YouTube, damos uma nota de 0 a 100 e mostramos de onde saiu cada ponto.',
      acao: 'Rastrear meu site grátis',
      nota: '{paginas} páginas por mês no plano Basic, sem cartão.'
    },
    como: {
      titulo: 'Do endereço à nota',
      intro:
        'Uma execução é um rastreamento completo do site, do primeiro link ao último. Nada é analisado antes de ela terminar: um retrato pela metade não diz qual metade ficou de fora.',
      escopoTitulo: 'Você escolhe o escopo',
      escopoTexto:
        'Crie o projeto, um site ou um canal do YouTube, e diga até onde o rastreador vai. Antes de começar, a estimativa lê o seu sitemap e mostra quantos endereços entram, com exemplos.',
      escopoDominio: 'Todo link do domínio',
      escopoCaminho: 'Só abaixo do caminho inicial',
      escopoSubdominios: 'Com os subdomínios, que contam na mesma cota',
      rastreadorTitulo: 'O rastreador passa',
      rastreadorTexto:
        'Escrito em Rust, ele abre cada página como um navegador e anota 20 sinais dela, então o que só monta no cliente é lido pelo que mostra, não pelo HTML vazio. Ele obedece ao robots.txt e conta quantas páginas deixou de fora por causa dele.',
      fotografiaTitulo: 'Fica uma fotografia com data',
      fotografiaTexto:
        'Quando termina, a execução guarda o site daquele dia: uma nota, cinco áreas e, em cada página, o que falta. Um relatório de março continua dizendo em setembro o que dizia em março.',
      fotografiaCota: 'Página que respondeu sem conteúdo não desconta da cota',
      fotografiaRepetir: '“Repetir” rastreia exatamente as mesmas páginas',
      fotografiaHistorico: 'Histórico de {min} a {max} dias, ou sem limite no Business'
    },
    tela: {
      rotulo:
        'Tela do Silent Puma com uma execução concluída de {site}: nota {nota} de 100 em {paginas} páginas, e os pontos que cada área perdeu.',
      site: 'Site',
      execucao: 'Execução #{n} · {data}',
      enderecoInicial: 'Endereço inicial',
      ateOnde: 'Até onde o rastreador vai',
      seguirDominio: 'Seguir todo link do domínio',
      abaixoDoCaminho: 'Ficar abaixo do caminho inicial',
      incluirSubdominios: 'Incluir subdomínios',
      parametros: 'Parâmetros de URL',
      descartar: 'Descartar: cada página uma vez',
      manter: 'Manter: cada filtro vira uma página',
      estimativa: 'O sitemap lista {total} endereços. {casam} casam com os seus filtros.',
      iniciar: 'Iniciar execução',
      rastreando: 'Rastreando',
      deTotal: 'de {total} páginas',
      headless: 'Navegador headless',
      javascript: 'JavaScript renderizado',
      robots: '{n} endereços',
      robotsTexto: 'fechados pelo robots.txt',
      deCem: 'de 100',
      desde: '+{n} desde a execução #{anterior}, nas mesmas páginas',
      pontosPerdidos: 'Pontos perdidos por área',
      semMeta: 'sem meta description',
      tituloLongo: 'título com {n} caracteres',
      semH1: 'sem H1'
    },
    areas: {
      titulo: 'Cinco áreas, uma conta',
      formulaAntes: 'A nota parte de 100 e cada área perde',
      formulaConta: 'peso × páginas com problema ÷ total',
      formulaDepois: 'Uma página sem título e sem H1 conta uma vez.',
      pontos: '{area}, {n} pontos',
      indexacao1: 'Responde com status 2xx',
      indexacao2: 'Renderiza e entrega conteúdo de verdade',
      indexacao3: 'Tem tag canonical',
      indexacao4: 'Vem primeiro: se o rastreador não chega à página, o resto não importa',
      conteudo1: 'Título, descrição e H1 presentes: é o que entra na nota',
      conteudo2: 'Título medido contra {min} a {max} caracteres',
      conteudo3: 'Descrição contra {min} a {max}',
      conteudo4: 'Menos de {n} palavras vira pedido de revisão, não regra',
      experiencia1: 'Resposta do servidor abaixo de {lenta} s; acima de {critica} s é crítica',
      experiencia2: 'Meta viewport presente',
      experiencia3: 'Página com menos de {mb} MB',
      experiencia4: 'Medimos o servidor, não o LCP, e o painel diz isso',
      midia1: 'Toda imagem com texto alternativo',
      midia2: 'Imagens contadas página por página',
      midia3: 'A lista sai pronta para quem vai preencher',
      links1: 'Nenhum link quebrado',
      links2: 'Ao menos um link interno: página sem link é página órfã',
      links3: 'Links internos e externos contados por página',
      controle: {
        indexacao: 'Páginas com problema de indexação',
        conteudo: 'Páginas com problema de conteúdo',
        experiencia: 'Páginas com problema de experiência',
        midia: 'Páginas com problema de mídia',
        links: 'Páginas com problema de links'
      },
      deTotal: '{n} de {total}',
      fecho: 'A nota não é prova. É o mapa de onde se perde mais ponto por página tocada.',
      acao: 'Ver a conta do meu site',
      statusDasPaginas: 'Status das páginas',
      semCanonical: 'Sem canonical',
      naoRenderizou: 'Não renderizou',
      comoAparece: 'Como aparece na busca',
      serpTitulo: 'Tênis de Corrida Pro X: Amortecimento Responsivo para…',
      caracteresAcima: '{n} caracteres, acima de {max}',
      semMetaBuscador: 'Sem meta description: o buscador escolhe um trecho da página.',
      semH1: 'Sem H1',
      tempoDeResposta: 'Tempo de resposta do servidor',
      lentasAcima: 'Lentas, acima de {s} s',
      semViewport: 'Sem viewport',
      imagensDaPagina: 'Imagens de uma página de produto',
      semAlt: 'sem alt',
      comAlt: 'com alt',
      paginasSemAlt: 'Páginas sem alt',
      linksQuebrados: 'Links quebrados',
      menuDoBlog: 'Os três estão no menu do blog, em {n} páginas.',
      semLinkInterno: 'Sem link interno'
    },
    saidas: {
      titulo: 'O que sai de cada execução',
      nome: {
        relatorio: 'Relatório',
        correcoes: 'Correções da IA',
        naSuaIa: 'Na sua IA',
        planilha: 'Planilha',
        canal: 'Canal do YouTube'
      },
      legenda: {
        relatorio:
          'Toda execução concluída vira um relatório de auditoria técnica para entregar ao cliente. Imprime em PDF pelo navegador, com texto pesquisável.',
        correcoes:
          'A IA lê o rastreamento e devolve de 4 a 10 correções, por impacto e, no mesmo impacto, pelo menor esforço. Cada uma diz quantas páginas toca.',
        naSuaIa:
          'O conector leva os seus rastreamentos para o Claude, o ChatGPT ou o Cursor. Por padrão ele só lê, e ler não gasta crédito nem cota.',
        planilha:
          'Todas as páginas em CSV, cada uma com o que o rastreador mediu e os problemas que ela tem. A exportação sai em fluxo, então funciona em qualquer tamanho.',
        canal:
          'Um projeto também pode ser um canal. A nota do canal tem quatro áreas: metadados {metadados}, engajamento {engajamento}, desempenho {desempenho} e publicação {publicacao}.'
      },
      relTitulo: 'Relatório de auditoria técnica',
      relMeta: '{site} · execução #{n} · {paginas}',
      resumo: 'Resumo',
      relResumo:
        'A indexação está saudável: {pct}% das páginas respondem 2xx e quase todas têm canonical. O que mais custa ponto é conteúdo, com {n} páginas de produto sem meta description.',
      deOndeSairam: 'De onde saíram os pontos',
      colArea: 'Área',
      colPeso: 'Peso',
      colPaginas: 'Páginas',
      colPerdidos: 'Perdidos',
      total: 'Total',
      prioridades: 'Prioridades',
      ia1: 'Escrever a meta description das páginas de produto',
      ia2: 'Trocar os três links do menu do blog que levam a 404',
      ia3: 'Dar canonical às páginas de filtro de categoria',
      ia4: 'Investigar a resposta lenta das páginas de categoria',
      ia5: 'Preencher o texto alternativo das fotos de produto',
      iaTitulo: 'Análise de IA',
      iaMeta: 'Padrão · {custo} · versão 2 · em português',
      iaResumo:
        'A indexação está saudável. O que mais pesa é conteúdo: as páginas de produto foram publicadas sem descrição, e o buscador está escolhendo trechos por conta própria.',
      mcpPergunta: 'Quais páginas da loja têm link quebrado?',
      mcpConsultou: 'Consultou o Silent Puma:',
      mcpExecucao: 'execução #{n}',
      mcpResposta1: '{n} páginas apontam para três endereços que respondem 404, todos no menu lateral do blog:',
      mcpResposta2: 'Corrigir o menu resolve as {n} de uma vez. Outras {m} páginas não recebem nenhum link interno.',
      mcpRodape: 'Conector de leitura: nenhuma ferramenta cria projeto, apaga execução ou mexe na sua conta.',
      canalMeta: 'Canal do YouTube · {videos} vídeos · execução #{n}',
      video1: 'Como escolher tênis para provas longas',
      video2: 'Treino intervalado em 20 minutos',
      video3: 'Unboxing: Pro X',
      tituloAcima: 'Título com {n} caracteres, acima de {max}',
      engajamentoAbaixo: 'Engajamento de {n}%, abaixo de {min}%',
      descricaoCurta: 'Descrição com menos de {min} caracteres'
    },
    degraus: {
      titulo: 'Comece no primeiro degrau',
      anual: 'Anual, {n} meses grátis',
      paraSempre: 'para sempre',
      comecarGratis: 'Começar grátis',
      assinar: 'Assinar o {plano}',
      falar: 'Falar com a gente',
      publico: {
        Basic: 'Para conferir o seu próprio site.',
        Guru: 'Para quem cuida de alguns sites.',
        Pro: 'Para agências com vários clientes.',
        Business: 'Para operações sem teto de páginas.'
      }
    },
    perguntas: {
      titulo: 'Perguntas diretas',
      p1: 'O que conta como página?',
      r1: 'Cada endereço rastreado no mês. Página que respondeu 2xx mas não entregou conteúdo, mesmo na segunda tentativa, não desconta da cota. O mês reinicia na data de cobrança.',
      p2: 'Vocês respeitam o robots.txt?',
      r2: 'Sim. O rastreador não entra em nada atrás de login nem em página que o site pede para não indexar, e a execução diz quantos endereços ficaram de fora por isso.',
      p3: 'Ele lê páginas montadas em JavaScript?',
      r3: 'Lê. Cada página é renderizada como num navegador, então vale o que ela mostra, não o HTML vazio que devolve.',
      p4: 'O tempo de carregamento é o Core Web Vitals?',
      r4: 'Não. Medimos a resposta do servidor, não o Largest Contentful Paint. Acima de {lenta} s a página é lenta; acima de {critica} s, crítica.',
      p5: 'Quanto custa uma análise de IA?',
      r5: 'A padrão custa um crédito e a profunda, dois. Ela nunca roda sozinha, só quando você pede. O Basic traz {basic} créditos por mês, o Guru {guru} e o Pro {pro}.',
      p6: 'O que vai para o provedor de IA?',
      r6: 'Métricas agregadas e uma amostra de endereços. Nunca os dados da sua conta nem as suas credenciais.',
      p7: 'Com quais IAs o conector funciona?',
      r7: 'Claude, ChatGPT e Cursor, nos planos Guru, Pro e Business. Por padrão ele só lê, e ler não gasta crédito nem cota.',
      p8: 'Como comparo duas datas?',
      r8: 'Use “Repetir” na lista de execuções: ele rastreia exatamente as páginas da execução anterior, e a diferença de nota passa a medir o site, não a amostra.',
      p9: 'Posso entregar o relatório ao cliente?',
      r9: 'Pode. Toda execução concluída vira um relatório de auditoria técnica, impresso em PDF pelo navegador, com texto pesquisável.',
      p10: 'Posso cancelar quando quiser?',
      r10: 'Pode. Cancelar mantém o plano até o fim do período já pago.'
    },
    contato: {
      titulo: 'Ficou alguma dúvida?',
      chamada: 'Escreva: respondemos em até um dia útil.',
      mensagem: 'Sua mensagem',
      mensagemExemplo: 'Quero acompanhar 4 domínios de clientes todo mês.',
      nome: 'Seu nome',
      email: 'Seu e-mail',
      emailExemplo: 'voce@empresa.com',
      ouEscreva: 'Ou escreva direto para',
      enviar: 'Enviar mensagem',
      enviando: 'Enviando…',
      enviada: 'Mensagem enviada. Respondemos em até um dia útil.',
      falhou: 'Não conseguimos enviar. Tente de novo em um minuto.'
    },
    cabecalho: {
      navegacao: 'Principal'
    },
    fecho: {
      navegacao: 'Seções da página',
      comoFunciona: 'Como funciona',
      cincoAreas: 'As cinco áreas',
      oQueSai: 'O que sai',
      perguntas: 'Perguntas',
      chat: 'Chat ao vivo nos planos Guru e Pro',
      conta: 'Conta',
      criarConta: 'Criar conta grátis',
      fotoAlt: 'Puma caminhando à noite em direção à câmera, fotografado por uma armadilha fotográfica.',
      fotoLegenda:
        'Santa Monica Mountains, 11 de abril de 2011, 1h25. Uma armadilha fotográfica registra o que passa, em silêncio, com data e hora.',
      fotoCredito: 'Foto: National Park Service, domínio público, via'
    }
  },

  precos: {
    titulo: 'Escolha seu plano',
    chamada: 'Comece a otimizar seu site hoje, com planos flexíveis',
    ciclo: 'Ciclo de cobrança',
    mensal: 'Mensal',
    anual: 'Anual',
    mesesGratis: '{n} meses grátis',
    maisPopular: 'Mais popular',
    personalizado: 'Sob consulta',
    porMes: '/mês',
    moedaSimbolo: 'US$',
    anualDetalhe: '/mês, cobrado por ano (US$ {valor})',
    carregando: 'Carregando…',
    faleConosco: 'Fale com a gente',
    comecar: 'Começar'
  },

  plano: {
    basicDescricao: 'Perfeito para começar',
    basicDestaque: 'Dashboard do site e do canal',
    guruDescricao: 'Ideal para times em crescimento',
    proDescricao: 'Para uso profissional',
    businessDescricao: 'Para grandes empresas',
    guruDestaque: 'Histórico de 30 dias e comparação entre execuções',
    proDestaque: 'Integrações com Google Analytics, Search Console e YouTube Analytics',
    businessDestaque: 'Tudo do Pro',
    conectorMcp: 'Conector MCP para a sua IA',
    suporteEmail: 'Suporte por e-mail',
    suporteChat: 'Suporte por chat',
    suportePrioritario: 'Suporte prioritário por chat',
    suporteDedicado: 'Suporte dedicado',
    projetos: { um: '{n} projeto', outros: '{n} projetos' },
    projetosIlimitados: 'Projetos ilimitados',
    paginasPorMes: '{n} páginas/mês',
    creditosPorMes: '{n} créditos de IA/mês',
    paginasIlimitadas: 'Páginas ilimitadas',
    creditosIlimitados: 'Créditos de IA ilimitados',
    retencao: 'Retenção de {n} dias',
    retencaoIlimitada: 'Retenção ilimitada'
  },

  planosTela: {
    publicoTitulo: 'Escolha seu plano',
    publicoChamada: 'Comece a otimizar seu site hoje. Cancele quando quiser.',
    titulo: 'Seu plano',
    gratuitoParaSempre: ', gratuito para sempre',
    cobradoStripe: ', cobrado pelo Stripe',
    faleConosco: 'Fale com a gente',
    comecar: 'Começar',
    planoAtual: 'Plano atual',
    cancelarAssinatura: 'Cancelar assinatura',
    melhorar: 'Melhorar',
    rebaixar: 'Rebaixar',
    atual: 'atual',
    assinaturaCancelada: 'Assinatura cancelada.',
    trocaRecebida: 'Troca de plano confirmada. O plano novo aparece aqui em instantes.',
    cobrancasRecentes: 'Cobranças recentes',
    historicoCompleto: 'Histórico completo',
    basicSemCobranca: 'O plano Basic é gratuito — não há o que cobrar.',
    semCobrancas: 'Nenhuma cobrança registrada ainda.'
  },

  pagamentos: {
    titulo: 'Histórico de cobranças',
    planos: 'Planos',
    basicGratis: 'O plano Basic é gratuito — nada é cobrado.',
    todasCobrancas: 'Todas as cobranças que o Stripe fez nesta conta.',
    semCobrancasBasic: 'Nenhuma cobrança no plano Basic.',
    semCobrancas: 'Nenhuma cobrança registrada ainda.',
    verPlanos: 'Ver planos',
    data: 'Data',
    descricao: 'Descrição',
    valor: 'Valor',
    status: 'Status',
    recibo: 'Recibo',
    ver: 'Ver',
    pago: 'pago',
    pendente: 'pendente',
    falhou: 'falhou',
    assinatura: 'Assinatura Silent Puma'
  },

  criar: {
    titulo: 'Criar novo projeto',
    chamada: 'Configure seu novo projeto de acompanhamento',
    nome: 'Nome do projeto',
    nomePlaceholder: 'Ex.: Meu canal ou site',
    tipo: 'Tipo de projeto',
    canalYoutube: 'Canal do YouTube',
    site: 'Site',
    url: 'URL',
    urlYoutube: 'https://www.youtube.com/@...',
    urlSite: 'https://www.meusite.com',
    ajudaYoutube: 'Informe a URL do seu canal no YouTube',
    ajudaSite: 'Informe a URL do seu site',
    criando: 'Criando…',
    criar: 'Criar projeto'
  },

  crawl: {
    carregando: 'Carregando…',
    titulo: 'Configuração da execução',
    chamada: 'Configure a execução para {nome}',
    tipoDeProjeto: 'Tipo de projeto',
    youtube: 'YouTube',
    site: 'Site',
    urlAlvo: 'URL de destino',
    usoDoPlano: 'Uso do plano',
    itensUsados: '{usados} de {total} itens usados',
    ilimitado: 'Ilimitado',
    nomeDaRun: 'Nome da execução',
    nomePlaceholder: 'Ex.: Checagem diária ou Análise semanal',
    nomeAjuda: 'Dê um nome descritivo para reconhecer a execução depois',
    limites: 'Limite do rastreamento',
    disponivel: '(Disponível: {n})',
    rastrearAte: 'Rastrear até',
    urls: 'URLs',
    limiteAjuda: 'Defina o número máximo de páginas a rastrear nesta execução',
    tudoSite: 'Rastrear o site todo',
    tudoCanal: 'Rastrear o canal todo',
    tudoAjuda:
      'O rastreamento vai até acabarem as páginas do site ou a cota do seu plano, o que vier primeiro.',
    tudoAjudaCanal:
      'O rastreamento vai até acabarem os vídeos do canal ou a cota do seu plano, o que vier primeiro.',
    tudoTeto: 'Há um teto de segurança de {n} páginas por execução, mesmo em plano ilimitado.',
    tudoEstimativa: 'Estimadas {n} páginas, e você tem {d} disponíveis.',
    tudoEstimativaExcede:
      'Estimadas {n} páginas, mais que as {d} disponíveis — o rastreamento vai parar na cota.',
    iniciar: 'Iniciar execução',

    configuracao: 'Configuração do rastreamento',
    comportamento: 'Comportamento do rastreamento',
    seguirTudo: 'Seguir todos os links',
    ficarNoDiretorio: 'Ficar no diretório atual',
    incluirSubdominios: 'Incluir subdomínios',
    seuDominio: 'seu domínio',
    ajudaDiretorio:
      'Só endereços abaixo do caminho inicial, em {raiz} ou www.{raiz}. Use para olhar uma seção sem rastrear o resto.',
    ajudaSubdominio:
      'Acrescenta qualquer subdomínio — blog.{raiz} e afins — a {raiz} e www.{raiz}. Todos contam na mesma cota de páginas.',
    ajudaTudo: 'Segue todo link encontrado, desde que fique em {raiz} ou www.{raiz}.',

    parametros: 'Parâmetros de URL',
    manterTodos: 'Manter todos os parâmetros',
    ignorarTodos: 'Ignorar todos os parâmetros',
    personalizado: 'Configuração personalizada',
    ajudaIgnorar:
      'Tudo depois do "?" é descartado, então a mesma página é rastreada uma vez. É o padrão seguro para a maioria dos sites.',
    ajudaPersonalizado:
      'Reservado para uma regra por parâmetro. Hoje se comporta como "Manter todos".',
    ajudaManter:
      'Cada combinação de parâmetros conta como uma página. Numa loja com filtros de cor e tamanho, um produto sozinho pode consumir dezenas de páginas da sua cota.',

    apenasUrls: 'Rastrear apenas URLs',
    tipoDeComparacao: 'Tipo de comparação',
    apenasPlaceholder: '{exemplo}  — deixe vazio para rastrear o site inteiro',
    apenasAjuda: 'Separe os termos por vírgula; a página que casar com qualquer um é rastreada.',
    excluirUrls: 'Pular URLs que contenham',
    excluirPlaceholder: '/institucional, /politica-de-privacidade',
    excluirAjuda: 'As exclusões têm prioridade sobre o campo acima.',
    exclusoesComuns: 'Exclusões comuns',
    exclusoesAjuda: 'Estas páginas raramente têm valor de SEO e consomem sua cota.',

    estimando: 'Consultando o site…',
    estimar: 'Estimar páginas correspondentes',
    estimativaAjuda:
      'Lido do sitemap do site. É uma estimativa: sitemaps ficam desatualizados, e páginas podem existir sem estar listadas.',
    correspondem: {
      um: '≈ {n} página corresponde aos seus filtros',
      outros: '≈ {n} páginas correspondem aos seus filtros'
    },
    deUrlsNoSitemap: 'De {encontradas} URLs listadas em {sitemaps}',
    umSitemap: 'um sitemap',
    variosSitemaps: '{n} sitemaps',
    sitemapTruncado: ' (o site tem mais do que conseguimos ler)',
    limiteCobreParte: ' Seu limite de {n} cobre parte disso.',
    pisoTitulo: 'Pelo menos {n} páginas correspondem',
    pisoDetalhe:
      'Este site não tem sitemap, então isto conta só os links da página inicial. O número real é bem provavelmente maior.',
    reescritoDetalhe:
      'De {encontradas} URLs. O sitemap deste site lista as páginas em {host} — a plataforma em que ele roda — e os mesmos endereços respondem no seu próprio domínio, então contamos por lá.',
    outroHostTitulo: 'Não dá para estimar por este sitemap',
    outroHostDetalhe:
      'O sitemap lista {encontradas} URLs, mas todas estão em {host} e não no domínio do seu projeto — comum quando a loja roda numa plataforma hospedada. Seus filtros apontam para o domínio do projeto, então os dois não se encontram. O rastreamento em si continua seguindo os links que achar no seu site.',
    nenhumaDetalhe:
      'Nenhum sitemap encontrado, e a página inicial não respondeu dentro do tempo, nem com erro. Pode ser instabilidade do site: tente estimar de novo em instantes. Se continuar, confira o endereço do projeto.',
    nenhumaBloqueado:
      'A página inicial respondeu {status}: o site está recusando o nosso rastreador, e o rastreamento vai bater na mesma porta.',

    avancado: 'Configurações avançadas',
    padroesPermitidos: 'Padrões de URL permitidos (regex)',
    remover: 'Remover',
    adicionarPadrao: 'Adicionar padrão'
  },

  filtro: {
    nenhum: 'nenhum filtro',
    paginacao: 'Paginação',
    paginacaoAjuda:
      'Páginas 2, 3, 4… de uma listagem. Repetem os mesmos produtos e multiplicam sua contagem de páginas.',
    busca: 'Busca e ordenação',
    buscaAjuda:
      'Resultados de busca e listagens ordenadas ou filtradas. Numa loja com facetas, podem ser milhares de URLs mostrando o mesmo catálogo.',
    conta: 'Carrinho e conta',
    contaAjuda: 'Carrinho, checkout, login e conta. Não são feitas para ser indexadas.',
    blog: 'Blog',
    blogAjuda: 'Útil quando você quer olhar só o catálogo.',

    contendo: 'contendo',
    contendoExemplo: '/produto, /categoria',
    contendoAjuda:
      'O termo aparece em qualquer lugar da URL. É a opção mais ampla — "/p" também casa "/politica-de-privacidade".',
    comecandoCom: 'começando com',
    comecandoExemplo: '/loja, /catalogo',
    comecandoAjuda: 'Lê a partir do domínio. Use para rastrear uma seção do site.',
    terminandoCom: 'terminando com',
    terminandoExemplo: '/p',
    terminandoAjuda:
      'A URL termina com o termo. É assim que se isola a página de produto da VTEX com "/p" sem pegar "/politica-de-privacidade".',
    igualA: 'igual a',
    igualExemplo: '/sobre, /contato',
    igualAjuda: 'Só estes endereços exatos são rastreados.'
  },

  metrica: {
    titulo: 'Título',
    descricao: 'Descrição',
    h1: 'H1',
    thumbnail: 'Thumbnail',
    comAlt: 'Com alt',
    semAlt: 'Sem alt',
    interno: 'Internos',
    externo: 'Externos',
    views: 'Visualizações',
    curtidas: 'Curtidas'
  },

  secao: {
    vazioVideos: 'Nenhum vídeo coletado nesta seleção.',
    vazioData: 'Nenhum vídeo desta seleção tem data de publicação registrada.',
    semCanonical: 'Sem tag canônica',
    semTitulo: 'Sem título',
    semDescricao: 'Sem descrição',
    semH1: 'Sem H1',
    tituloForaDaFaixa: 'Título fora da faixa',
    descricaoForaDaFaixa: 'Descrição fora da faixa',
    conteudoRaso: 'Conteúdo raso',
    semViewport: 'Sem viewport',
    semOgImagem: 'Sem og:image',
    ogImagemRepetida: 'og:image repetida',
    ytSemDescricao: 'Sem descrição',
    descricaoCurta: 'Descrição curta',
    tituloLongo: 'Título longo',
    semThumbnail: 'Sem thumbnail',
    totalVideos: 'Vídeos',
    totalViews: 'Visualizações',
    mediaPorVideo: 'Média por vídeo',
    abaixoDaMediaNota: '{n} abaixo da média',
    maisVistos: 'Mais vistos',
    taxaGeral: 'Engajamento geral',
    taxaGeralNota: 'saudável a partir de {n}%',
    engajamentoBaixo: 'Engajamento baixo',
    maisEngajados: 'Mais engajados',
    semData: 'Sem data'
  },

  painelSite: {
    titulo: 'Painel de análise do site',
    abaVisao: 'Visão geral',
    abaIndexacao: 'Indexação',
    abaConteudo: 'Conteúdo',
    abaExperiencia: 'Experiência',
    abaMidia: 'Mídia',
    abaLinks: 'Links',
    abaTrafego: 'Busca e tráfego',
    filtros: 'Filtros',
    tempoCarga: 'Tempo de carga',
    abaDados: 'Dados',
    paginasRastreadas: 'Páginas rastreadas',
    cargaMedia: 'Tempo médio de carga',
    tamanhoMedio: 'Tamanho médio da página',
    score: 'Score de SEO',
    scoreAjuda:
      'Parte de 100 e perde uma parcela do peso de cada área na proporção das páginas afetadas: indexação 25, conteúdo 30, experiência 20, links 15, mídia 10. Só vale lido contra outra execução do mesmo site — o relatório mostra essa comparação.',
    semTitulo: 'Sem título',
    semDescricao: 'Sem descrição',
    execucao: 'Execução:',
    execucaoSemNome: 'Execução sem nome',
    url: 'URL:',
    igual: 'Igual a',
    contem: 'Contém',
    naoContem: 'Não contém',
    comecaCom: 'Começa com',
    terminaCom: 'Termina com',
    urlPlaceholder: 'Digite a URL...',
    status: 'Status:',
    todosStatus: 'Todos os status',
    status200: '200 - Sucesso',
    status301: '301 - Movido permanentemente',
    status302: '302 - Encontrado',
    status400: '400 - Requisição inválida',
    status404: '404 - Não encontrado',
    status500: '500 - Erro no servidor',
    tempoDeCarga: 'Tempo de carga (ms):',
    limpar: 'Limpar',
    semExecucoesConcluidas:
      'Nenhuma execução concluída neste projeto. O painel mede uma execução por vez — rode uma para ver os números.',
    paginasComErro: 'Páginas com erro',
    paginasComErroAjuda:
      'Respostas 4xx e 5xx. O buscador não indexa o que não consegue abrir, e link interno apontando para cá desperdiça rastreamento.',
    grafico: {
      desempenho: 'Desempenho',
      seo: 'SEO na página',
      arquitetura: 'Conteúdo e arquitetura',
      cargaTitulo: 'Distribuição do tempo de carga',
      cargaNota:
        'A cor é julgamento: verde dentro da meta, vermelho acima de 3 segundos.',
      statusTitulo: 'Códigos HTTP',
      statusNota: 'Sobre as respostas desta execução.',
      statusCentro: 'respostas',
      problemasTitulo: 'Problemas de SEO',
      problemasNota:
        'Críticos primeiro, depois avisos, cada grupo por volume; a barra é a parcela das páginas rastreadas. Clique num problema para ver as páginas na tabela.',
      problemasVazio: 'Nenhum problema nas áreas medidas.',
      canonical: 'Tag canônica',
      coberturaTitulo: 'Cobertura de meta tags',
      coberturaNota:
        'Presença por tag. A canônica entra aqui porque é ela que separa página duplicada de página nova.',
      profundidadeTitulo: 'Profundidade de clique',
      profundidadeNota:
        'Quantos cliques da URL inicial até a página. A partir de quatro ela fica difícil de alcançar, para a pessoa e para o rastreador.',
      profundidadeVazio:
        'Esta execução não registrou profundidade. Repetições de execuções anteriores a essa medida não têm nível de onde herdar.',
      profundidadeRaiz: 'inicial',
      acessoTitulo: 'Mídia e acesso',
      acessoNota: 'Três presenças que decidem se a página é encontrada e entendida.',
      imagensComAlt: 'Imagens com texto alternativo',
      comLinkInterno: 'Páginas com link interno de saída',
      comViewport: 'Páginas com viewport',
      com: 'com',
      sem: 'sem'
    }
  },

  painelYt: {
    titulo: 'Painel do YouTube',
    execucao: 'Execução:',
    execucaoNumero: 'Execução {n}',
    buscarTitulo: 'Buscar por título:',
    tituloPlaceholder: 'Digite o título...',
    faixaViews: 'Faixa de visualizações:',
    faixaCurtidas: 'Faixa de curtidas:',
    faixaComentarios: 'Faixa de comentários:',
    filtros: 'Filtros',
    videos: 'Vídeos',
    score: 'Score do canal',
    scoreAjuda:
      'Parte de 100 e perde uma parcela do peso de cada área na proporção dos vídeos afetados: metadados 35, engajamento 30, desempenho 25, publicação 10. Só vale lido contra outra execução do mesmo canal.',
    semExecucoesConcluidas:
      'Nenhuma execução concluída neste projeto. O painel mede uma execução por vez — rode uma para ver os números.',
    grafico: {
      porMesTitulo: 'Views por vídeo publicado',
      porMesNota:
        'Média por vídeo do mês, e não o total: o total premiaria o mês em que se publicou mais.',
      porMesVazio: 'Nenhum vídeo desta execução tem data de publicação para agrupar por mês.',
      tagsTitulo: 'Tags com mais engajamento',
      tagsNota:
        'Sobre o que o canal engaja, não sobre o que ele publica. A taxa é agregada, e tag de um vídeo só fica de fora.',
      tagsVazio: 'Nenhuma tag se repete em dois vídeos com visualizações.',
      distribuicaoTitulo: 'Distribuição de visualizações',
      distribuicaoNota: 'Quantos vídeos há em cada faixa de alcance.',
      maisVistosNota: 'Os cinco de maior alcance nesta execução.',
      dispersaoTitulo: 'Visualizações × curtidas',
      dispersaoNota:
        'Ponto acima da tendência é vídeo que engajou mais do que o alcance sugeriria.',
      dispersaoVazio: 'Poucos vídeos com visualização para desenhar a nuvem.',
      maisEngajadosNota: 'Curtidas e comentários sobre visualizações, por vídeo.',
      atencaoTitulo: 'Pontos de atenção',
      atencaoNota:
        'Ordenado por volume. Tags não entram: o YouTube diz que têm papel mínimo na descoberta.',
      atencaoVazio: 'Nenhum ponto de atenção nas áreas medidas.',
      porDiaTitulo: 'Publicação por dia da semana',
      porDiaNota: 'Média de visualizações por vídeo publicado no dia, e não o total do dia.'
    }
  },

  colunaYt: {
    legenda: 'Legenda',
    comLegenda: 'sim',
    semLegenda: 'não',
    tags: 'Tags',
    comentarios: 'Comentários',
    publicadoEm: 'Publicado em',
    videoId: 'ID do vídeo',
    engajamento: 'Engajamento',
    naoCurtidas: 'Não curtidas',
    url: 'URL',
    canal: 'Canal',
    execucao: 'Execução'
  },

  tabela: {
    colEstrutura: 'Estrutura',
    colAutor: 'Autor',
    colAtualizado: 'Atualizado em',
    colDensidade: 'Conteúdo no main',
    colProduto: 'Schema de produto',
    estrutura: {
      semPreco: 'sem preço',
      semDisponibilidade: 'sem disponibilidade',
      semMarca: 'sem marca',
      semAvaliacao: 'sem avaliação',
      ok: 'ok',
      semHeadings: 'sem títulos',
      semH1: 'sem H1',
      multiplosH1: 'vários H1',
      saltoDeNivel: 'salto de nível'
    },
    min: 'Mín',
    max: 'Máx',
    selecionarColunas: 'Selecionar colunas',
    colunasVisiveis: 'Colunas visíveis',
    selecionarTodas: 'Selecionar todas',
    baixarCsv: 'Baixar CSV',
    linhasPorPagina: 'Linhas por página:',
    intervalo: '{de}-{ate} de {total}',
    colUrl: 'URL',
    colStatus: 'Status',
    colCarga: 'Resposta do HTML (ms)',
    colTamanho: 'Tamanho (KB)',
    colScore: 'Score de SEO',
    colTitulo: 'Título',
    colDescricao: 'Meta description',
    colH1: 'Tags H1',
    colLinksQuebrados: 'Links quebrados',
    colLinksQuebradosProprios: 'Links quebrados (próprios)',
    colCliques: 'Cliques',
    colImpressoes: 'Impressões',
    colCtr: 'CTR',
    colPosicao: 'Posição média',
    colSessoes: 'Sessões',
    colConversoes: 'Conversões',
    colRejeicao: 'Rejeição',
    colEngajamento: 'Engajamento/sessão',
    colViewsPorSessao: 'Páginas/sessão'
  },

  otim: {
    titulo: 'Otimizações recomendadas',
    execucao: 'Execução: {nome}',
    carregando: 'Carregando…',
    analisando: 'Analisando…',
    gerar: 'Gerar',
    gerarDeNovo: 'Gerar de novo',
    custo: { um: '{n} crédito', outros: '{n} créditos' },
    comCusto: '{acao} ({custo})',
    padraoRotulo: 'Análise padrão',
    padraoDescricao: 'Profundidade suficiente para checagens de rotina e execuções recorrentes.',
    profundaRotulo: 'Análise profunda',
    profundaDescricao: 'Mais raciocínio em sites complexos. Custa mais créditos.',
    foco: 'Foco desta análise',
    opcional: '(opcional)',
    focoExemploSite: 'ex.: priorize as páginas de produto, ignore o blog, o site é mobile-first.',
    focoExemploYoutube:
      'ex.: é um canal de tutoriais, quero mais inscritos, foque nos vídeos de 2026.',
    demora:
      'Isto leva alguns minutos. Deixe esta página aberta — o resultado aparece aqui quando ficar pronto.',
    versoes: 'Versões desta execução:',
    maisRecente: 'mais recente',
    semModelo: 'modelo não registrado',
    focoUsado: 'Foco pedido nesta versão:',
    vazio: 'Nenhuma otimização foi gerada para esta execução ainda.',
    vazioAjudaSite:
      'A IA lê os dados do seu crawl e devolve uma lista priorizada do que corrigir primeiro, com o número de páginas afetadas.',
    vazioAjudaYoutube:
      'A IA lê os vídeos coletados e devolve uma lista priorizada do que ajustar primeiro, com o número de vídeos afetados.',
    resumo: 'Visão geral',
    impacto: 'Impacto {nivel}',
    esforco: 'Esforço {nivel}',
    oQueFazer: 'O que fazer:',
    geradoEm: 'Gerado em {data} · {tokens} tokens',
    voltar: 'Voltar para os projetos',

    nivelAlto: 'alto',
    nivelMedio: 'médio',
    nivelBaixo: 'baixo',
    paginas: { um: '{n} página', outros: '{n} páginas' },
    videos: { um: '{n} vídeo', outros: '{n} vídeos' },

    catIndexacao: 'Indexação',
    catConteudo: 'Conteúdo',
    catExperiencia: 'Experiência',
    catMidia: 'Mídia',
    catLinks: 'Links',
    catEstruturados: 'Dados estruturados',
    catDesempenho: 'Desempenho',
    catMetadados: 'Metadados',
    catEngajamento: 'Engajamento',
    catPublicacao: 'Publicação'
  },

  relatorio: {
    voltar: '← Voltar para as execuções',
    execucaoDoRelatorio: 'Execução deste relatório',
    salvarPdf: 'Salvar em PDF',
    carregando: 'Carregando…',
    tipo: 'Auditoria técnica',
    seloGerado: 'Silent Puma · relatório gerado em {data}',
    titulo: 'Relatório de auditoria técnica',
    tituloDocumento: 'Silent Puma — {projeto} — execução {run}',
    opcaoExecucao: '#{id} — {nome} — {data}',
    semRunConcluida:
      'Este projeto ainda não tem execução concluída. O relatório é montado a partir de um crawl terminado —',
    comeceUma: 'inicie um',
    eVolte: 'e volte quando ele terminar.',

    paginasAnalisadas: 'Páginas analisadas',
    acessiveis: 'Acessíveis',
    score: 'Score de SEO',
    problemasEncontrados: 'Problemas encontrados',
    rastreadoEm: 'Rastreado em',

    resumo: 'Resumo',
    prioridades: 'Prioridades',
    oQueFazer: 'O que fazer',
    onde: 'Onde',
    alcance: 'Alcance',

    metricas: 'Métricas técnicas',
    metrica: 'Métrica',
    medido: 'Medido',
    referencia: 'Referência',
    veredicto: 'Veredicto',
    tituloCanal: 'Auditoria de canal',
    videosAnalisados: 'Vídeos analisados',
    coletadoEm: 'Coletado em',
    tag: 'Tag',
    videos: 'Vídeos',
    metodologiaColeta:
      'A coleta percorreu {paginas} do canal {alvo} em {data}, na execução #{run}. Os números deste relatório são o retrato daquele momento: visualizações, curtidas e comentários continuam mudando depois dele.',
    metodologiaFaixasCanal:
      'Título é considerado longo acima de {titulo} caracteres, que é onde o YouTube começa a truncá-lo na busca e nas sugestões. A descrição é tratada como curta abaixo de {descricao} caracteres, o trecho que aparece no resultado de busca. Engajamento é a soma de curtidas e comentários sobre visualizações, e {engajamento}% é a convenção de mercado para uma taxa saudável — referência, não meta.',
    metodologiaCanalNota:
      'Tags entram como informação de repertório, não como problema a corrigir: o próprio YouTube afirma que elas têm papel mínimo na descoberta. A tabela de tags mede o engajamento dos vídeos que as carregam, o que diz sobre o assunto, não sobre a tag.',
    scoreCanal: 'Score do canal',
    porAreaNotaCanal:
      'Um vídeo pode aparecer em mais de uma área — o mesmo vídeo pode estar sem descrição e com pouco engajamento.',
    scoreNotaCanal:
      'O score parte de 100 e perde uma parcela do peso de cada área na proporção dos vídeos afetados: metadados 35, engajamento 30, desempenho 25, publicação 10. Um vídeo com três defeitos de metadados conta uma vez — é um vídeo a arrumar, não três.',
    vOk: 'ok',
    vAviso: 'revisar',
    vCrit: 'crítico',

    linhaAcessiveis: 'Páginas respondendo 2xx',
    linhaComTitulo: 'Páginas com título',
    linhaTituloNaFaixa: 'Títulos dentro da faixa',
    linhaComDescricao: 'Páginas com meta description',
    linhaDescricaoNaFaixa: 'Descrições dentro da faixa',
    linhaComH1: 'Páginas com H1',
    linhaComCanonical: 'Páginas com tag canônica',
    linhaComViewport: 'Páginas com meta viewport',
    linhaRespostaMedia: 'Resposta média do servidor',
    linhaLentas: 'Páginas mais lentas que 3s',
    linhaPesoMedio: 'Peso médio da página',
    linhaComAlt: 'Imagens com texto alternativo',
    linhaLinksQuebrados: 'Páginas com links quebrados',
    linhaSemLinkInterno: 'Páginas sem link interno',
    linhaSemRender: 'Páginas que não renderizaram',
    refCaracteres: '{min}–{max} caracteres',
    refAbaixoDe: 'abaixo de {n}',

    porArea: 'Problemas por área',
    porAreaNota:
      'Uma página pode aparecer em mais de uma área — a mesma página pode estar sem título e carregando devagar.',

    scoreEntreRuns: 'Score ao longo das execuções',
    de100: 'de 100',
    desdeRun: '{sinal}{n} desde a execução #{id}',
    scoreDaBarra: 'Execução #{id}: {score}',
    scoreNota:
      'O score parte de 100 e perde uma parcela do peso de cada área na proporção das páginas afetadas: indexação 25, conteúdo 30, experiência 20, links 15, mídia 10. Uma página com três problemas na mesma área conta uma vez — é uma página a corrigir, não três.',
    mesmaAmostra:
      'Esta execução repetiu exatamente as páginas da execução #{id}, então a diferença acima reflete mudanças no site — não uma amostra diferente.',
    amostraDiferente:
      'Atenção: a execução #{id} cobriu {anteriores} páginas e esta cobriu {atuais}. Cada execução descobre as páginas a partir da URL inicial, então um conjunto diferente pode mover o score sozinho — use Repetir na lista de execuções para medir as mesmas páginas de novo.',

    profundidade: 'Profundidade de navegação',
    nivel: 'Nível',
    paginas: 'Páginas',
    fatia: 'Fatia',
    paginaInicial: 'Página inicial',
    cliquesDeDistancia: { um: 'a {n} clique', outros: 'a {n} cliques' },
    profundidadeNota:
      'A profundidade é o caminho mais curto a partir da página inicial. Páginas a quatro ou mais cliques são rastreadas com menos frequência pelos buscadores e são mais difíceis de alcançar.',

    metodologia: 'Metodologia',
    metodologiaCrawl:
      'O Silent Puma rastreou {paginas} de {alvo} em {data}, seguindo o escopo e os limites configurados para a execução #{run}. Cada página foi buscada uma vez e medida como o servidor a entregou.',
    metodologiaFaixas:
      'As faixas de título e descrição ({tituloMin}–{tituloMax} e {metaMin}–{metaMax} caracteres) são as janelas que costumam aparecer sem corte no resultado de busca — o Google não publica um tamanho oficial. O limiar de {carga}s de resposta é mais rígido do que os Core Web Vitals exigem, de propósito: medimos resposta do servidor, não Largest Contentful Paint.',
    metodologiaRender:
      'Páginas que responderam com status 2xx mas entregaram nenhum título, nenhum H1 e nenhum link interno são reportadas como "não renderizaram". Elas apontam para infraestrutura, não para conteúdo faltando, e não contam na cota do seu plano.',
    semIa:
      'Este relatório não tem as seções Resumo e Prioridades porque nenhuma análise de IA foi gerada para esta execução. Elas vêm de lá.',

    duvidas: 'Dúvidas sobre este relatório: {email}',
    confidencial: 'Confidencial · uso do cliente',
    recorte: 'As {n} primeiras de {total}. A lista completa está no painel.',
    falhou: 'Não foi possível carregar esta seção.',
    periodo: 'Período',
    canal: 'Canal',
    finalidade: 'Finalidade',
    rastreador: 'Rastreador',
    acesso: 'Acesso',
    regra: 'Regra no robots.txt',
    dominio: 'Domínio',
    termos: 'Termos',
    antes: 'Antes',
    agora: 'Agora',
    pioresPaginas: 'As {n} páginas com a nota mais baixa',
    plano: {
      gsc: 'Disponível nos planos Pro e Business, com o Search Console conectado.',
      ga4: 'Disponível nos planos Pro e Business, com o Google Analytics conectado.',
      gscGa4: 'Disponível nos planos Pro e Business, com o Search Console e o Google Analytics conectados.',
      youtube: 'Disponível nos planos Pro e Business, com o YouTube Analytics conectado.'
    }
  },

  runAnalise: {
    titulo: 'Análise da execução #{id}',
    paginas: { um: '{n} página', outros: '{n} páginas' },
    baixarCsv: 'Baixar CSV',
    baixarPdf: 'Baixar relatório PDF',
    score: 'Score de SEO',
    de100: 'de 100',
    variacao: '{sinal}{n} vs. execução #{run}',
    paginasAnalisadas: 'Páginas analisadas',
    verTodas: 'Ver todas as páginas',
    puladasPeloRobots:
      '{n} não foram rastreadas: o robots.txt do site proíbe. Se não for intencional, é ali que se libera.',
    bloqueado: {
      titulo: 'Este site não deixou rastrear',
      comStatus:
        'O endereço inicial respondeu {status}, então não chegamos a ver o site. Não há nota nem diagnóstico nesta execução — o que aparece abaixo é só o que a página de bloqueio trouxe.',
      semStatus:
        '{n} de {total} páginas foram recusadas, então não sobrou site para medir. Não há nota nesta execução.',
      comoLiberar:
        'Se o site é seu, libere o agente {agente} no seu WAF ou CDN e rode de novo. Se não é, não há o que fazer daqui — e contornar a proteção não é algo que façamos.'
    },
    problemas: 'Problemas encontrados',
    maiorParteEm: { um: '{n} problema em {area}', outros: '{n} problemas em {area}' },
    semProblemas: 'Nenhum problema nas cinco áreas.',
    respostaMedia: 'Resposta média',
    acimaDoLimite: { um: '{n} página lenta', outros: '{n} páginas lentas' },
    analiseIa: 'Análise de IA',
    tokens: { um: '{n} TOKEN', outros: '{n} TOKENS' },
    verOtimizacoes: 'Ver otimizações',
    gerarOtimizacoes: 'Gerar otimizações',
    semAnalise: 'Esta execução ainda não tem análise de IA. Gerar consome um crédito.',
    ondeEstaoAsPerdas: 'Onde estão as perdas',
    nenhumaPerda: 'Nenhuma página com problema nas áreas medidas.',
    perda: {
      semTitulo: 'Sem título',
      semDescricao: 'Sem meta description',
      semH1: 'Sem H1',
      semAlt: 'Imagens sem alt',
      semCanonical: 'Sem canonical',
      linksQuebrados: 'Com links quebrados',
      lentas: 'Carregamento lento',
      semLinkInterno: 'Sem link interno de saída',
      semViewport: 'Sem viewport'
    },
    canal: {
      views: 'Visualizações totais',
      likes: 'Curtidas totais',
      comentarios: 'Comentários por vídeo',
      engajamento: 'Taxa de engajamento',
      semVariacao: 'Sem variação',
      varPct: '{sinal}{n}% vs. execução #{run}',
      varPorVideo: '{sinal}{n} por vídeo vs. #{run}',
      varPontos: '{sinal}{n} p.p. vs. #{run}',
      videos: { um: '{n} vídeo', outros: '{n} vídeos' },
      tagsTitulo: 'Tags com mais engajamento',
      tagsVazio:
        'Nenhuma tag aparece em dois vídeos ou mais — sem repetição não dá para dizer se a tag engaja.',
      tagsNota:
        'Taxa agregada dos vídeos que carregam cada tag, e a barra é relativa à primeira. Só entram tags com dois vídeos ou mais.',
      medidas: 'Medidas do canal',
      comDescricao: 'Vídeos com descrição',
      descricaoInformativa: 'Descrição informativa',
      tituloNoLimite: 'Título dentro do limite',
      comThumbnail: 'Vídeos com thumbnail',
      engajamentoBaixo: 'Vídeos com engajamento baixo',
      refMinimo: 'mínimo de {n} caracteres',
      refAte: 'até {n} caracteres',
      refAcima: 'acima de {n}%',
      vazio: 'Esta execução não coletou nenhum vídeo.',
      rodapeRelatorio: 'As tags por engajamento e a metodologia estão no',
      rodape: 'Cada vídeo, com filtro e ordenação, está em',
      verVideos: 'todos os vídeos'
    },
    metricasTecnicas: 'Métricas técnicas',
    rodape: 'As outras nove medidas técnicas estão no',
    rodapeLink: 'relatório completo'
  },

  canal: {
    titulo: 'Desempenho do canal',
    intro: 'O que a API pública não conta: de que busca veio o tráfego e quanto do vídeo foi assistido. Janela de 28 dias, encerrada há 4 dias para o YouTube consolidar.',
    naoConectado: 'Esta execução não tem leitura de desempenho. Conecte o YouTube Analytics nas integrações do projeto e rode de novo.',
    retencao: 'Retenção média',
    retencaoAjuda: 'Quanto do vídeo foi assistido, em média, ponderado pelas views — um vídeo com 4 views não pesa o mesmo que um com 40 mil. É o mais próximo de CTR de miniatura que a API oferece: impressão e CTR são medidas do YouTube Studio e não existem aqui.',
    tempoAssistido: 'Minutos assistidos',
    tempoAssistidoAjuda: 'Soma do tempo assistido na janela. É a medida que mais pesa na recomendação do YouTube — mais que a contagem de views.',
    inscritos: 'Inscritos no período',
    inscritosAjuda: 'Ganhos menos perdidos, somando os vídeos com leitura. Separa o vídeo que atrai do vídeo que converte.',
    termos: 'Termos de busca',
    teto: 'A API do YouTube devolve no máximo {teto} termos por consulta, e não há paginação. A lista abaixo é o topo por views — não é a lista completa.',
    tituloTermos: 'O que digitaram para chegar',
    termosDoCanal: 'A API recusou o filtro por vídeo nesta leitura, então os termos são do canal inteiro, e não de um vídeo específico.',
    semTermos: 'Nenhum termo de busca na janela.',
    tituloVideos: 'Retenção por vídeo',
    semVideos: 'Nenhum vídeo com leitura de desempenho na janela.',
    termo: 'Termo',
    video: 'Vídeo',
    views: 'Views',
    minutos: 'Minutos',
    retencaoCurta: 'Retenção',
    duracaoMedia: 'Duração média',
    inscritosCurto: 'Inscritos'
  },

  intencao: {
    titulo: 'Intenção de busca',
    intro: 'O que o Google mostra no top 10 de cada termo, agrupado pelo que a pessoa quer, e se a sua página é do tipo certo.',
    ler: 'Ler intenção com IA (1 crédito)',
    lerDeNovo: 'Ler de novo (1 crédito)',
    lendo: 'Lendo…',
    naoLido: 'Ainda não lida nesta execução. A leitura usa o top 10 do Google que a execução já guardou.',
    indisponivel: 'Esta execução não guardou o top 10 do Google. As próximas execuções com Search Console guardam.',
    nota: 'A IA só agrupa os resultados e julga o tipo da sua página; as porcentagens são contadas sobre o top 10. É um retrato do celular no momento da execução.',
    termo: 'Termo',
    googleMostra: 'O Google mostra',
    suaPagina: 'Sua página',
    fatia: '{pct}% · {forma}',
    posicao: '{pos}º',
    foraDoTopo: 'fora do top 10',
    encaixe: {
      sim: 'tipo certo',
      parcial: 'em parte',
      nao: 'tipo errado',
      sem_pagina: 'sem página'
    }
  },
  canibalizacao: {
    titulo: 'Páginas disputando o mesmo termo',
    intro: 'Termos em que o Google divide as impressões entre páginas do seu site, medido no Search Console.',
    resumo: '{n} termos em disputa.',
    risco: 'Cerca de {cliques} cliques em risco.',
    semDados: 'Sem dados do Search Console nas páginas rastreadas, então não há como ver disputa entre elas.',
    nenhum: 'Nenhum termo com duas páginas disputando de verdade. Cada termo com procura tem uma página que responde por ele.',
    acao: 'Se as páginas atendem à mesma busca, junte o conteúdo na principal e redirecione a outra (301). Se atendem a buscas diferentes — uma categoria e um produto, por exemplo —, mantenha as duas e deixe claro qual responde pelo termo: título, link interno e canônica apontando para ela.',
    estimativa: 'Cliques em risco: o que as outras páginas renderiam se as impressões delas fossem para a principal, pelo CTR que o seu site tira na posição dela. É estimativa, e fica em branco quando o site não tem amostra naquela posição. Termos com o nome da marca ficam fora: ali o Google mostra várias páginas do site de propósito.',
    termo: 'Termo',
    paginas: 'Páginas',
    principal: 'principal',
    detalhe: '{imp} impr. · pos. {pos}',
    impressoes: 'Impressões',
    cliques: 'Cliques',
    emRisco: 'Cliques em risco',
    erro: 'Não foi possível carregar as páginas em disputa.'
  },
  oportunidades: {
    avaliar: 'Avaliar relevância com IA (1 crédito)',
    avaliando: 'Avaliando…',
    reavaliar: 'Avaliar de novo (1 crédito)',
    relevancia: 'A página merece?',
    rel: {
      alta: 'sim, falta ajuste',
      media: 'em parte',
      baixa: 'não é esta página'
    },
    alvo: 'O ganho por posição é estimado contra a {alvo}ª colocação.',
    semTopo: 'Fora os termos com o nome da sua marca, o site não aparece entre as primeiras posições para nenhuma busca com procura relevante — a medição só começa na {alvo}ª. Por isso o ganho de posição é estimado contra ela, e não contra o topo: é a melhor colocação que o site de fato alcança hoje.',
    foraMarca: '{n} termos com o nome “{marca}” ficaram fora: busca pela própria marca não é oportunidade, e o CTR dela é alto demais para servir de referência às outras.',
    foraCanibal: '{n} pares ficaram fora por disputarem um termo já contado em outra página. O clique não viria duas vezes — mas duas páginas no mesmo termo é um problema por si só.',
    titulo: 'Oportunidades',
    intro: 'Ganho em cliques pela curva de CTR do próprio site.',
    semCurva: 'Ainda não há busca suficiente nas páginas rastreadas para medir quanto o seu site converte em cada posição. Sem essa curva, qualquer estimativa de ganho seria chute.',
    estimativa: 'Os ganhos são estimativa, não previsão. Saem do CTR que o seu próprio site tira em cada posição, e o ganho por posição é calculado de forma conservadora — mantendo as impressões atuais, que na prática aumentam quando a página sobe.',
    verCurva: 'Ver a curva de CTR do site',
    ocultarCurva: 'Ocultar a curva',
    ctrMedido: 'CTR medido',
    nenhuma: 'Nenhum par com ganho estimado relevante. É um bom sinal: o que tem demanda já está convertendo perto do que o site costuma converter.',
    termo: 'Termo',
    pagina: 'Página',
    acao: 'Ação',
    acaoTexto: 'Reescrever título e descrição',
    acaoConteudo: 'Trabalhar conteúdo e links',
    posicao: 'Posição',
    impressoes: 'Impressões',
    ctrAtual: 'CTR',
    ganho: 'Ganho est.',
    resumo: '+{ganho} cliques a ganhar em {n} pares de página e termo.'
  },

  integracoes: {
    titulo: 'Integrações',
    chamada:
      'Conecte o Google Analytics, o Search Console e o YouTube Analytics para cruzar desempenho com o que foi rastreado.',
    naoConectado: 'Não conectado',
    ativo: 'ativo',
    faltaEscolher: 'falta escolher a propriedade',
    conectadoEm: 'Conectado em {data}',
    conectar: 'Conectar',
    escolherPropriedade: 'Escolher propriedade',
    trocarPropriedade: 'Trocar propriedade',
    desconectar: 'Desconectar',
    semPropriedades: 'A conta conectada não tem nenhuma propriedade disponível para este serviço.',
    confirmarDesconexao:
      'Desconectar {nome} deste projeto? O acesso é revogado no Google e a escolha de propriedade se perde.',
    retornoOk:
      'Conta conectada. Falta escolher qual propriedade pertence a este projeto — sem ela, não há o que consultar.',
    retornoErro: 'Não foi possível concluir a conexão com o Google. Tente de novo.',
    nota: 'Só lemos: os escopos pedidos são de leitura. Nada é escrito na sua conta do Google, e a conexão pode ser revogada aqui a qualquer momento.',
    faltaEscolherCanal: 'falta escolher o canal',
    escolherCanal: 'Escolher canal',
    trocarCanal: 'Trocar canal',
    semCanais: 'A conta conectada não administra nenhum canal do YouTube.',
    retornoOkCanal: 'Conta conectada. Falta escolher qual canal pertence a este projeto — sem ele, não há o que consultar.',
    canalDivergente: 'O canal conectado não é o mesmo que esta execução rastreou, então o desempenho não foi lido. Escolha o canal certo e rode de novo.'
  },

  trafego: {
    ctr: 'CTR',
    rejeicao: 'Rejeição',
    periodo: 'Search Console e Analytics · {periodo} · {dias} dias, a janela que esta execução mediu',
    cobertura: {
      titulo: 'Cruzamento com o crawler',
      nota: 'Confira antes dos números: se as URLs não casarem, um zero abaixo parece medição e não é.'
    },
    tom: { ok: 'bom', warn: 'atenção', crit: 'ruim' },
    faixa: { ok: 'top 10', warn: 'página 2', crit: 'depois da página 2' },
    gsc: {
      rotulo: 'Antes do clique · Search Console',
      titulo: 'Como o site é encontrado',
      leituraTitulo: 'Aparece e não convence',
      leituraNota: '100+ impressões e CTR abaixo de 1%: o problema está no título e na descrição.',
      leituraMedida: '{impressoes} · {ctr}%'
    },
    ga: {
      rotulo: 'Depois do clique · Analytics',
      titulo: 'O que a visita faz',
      medias: 'Rejeição média de {rejeicao}, {engajamento} de engajamento e {paginas} páginas por sessão. No GA4, a rejeição é o inverso das sessões engajadas.',
      leituraTitulo: 'Recebe e rejeita',
      leituraNota: '20+ sessões e rejeição de 70% ou mais: o problema está depois do clique.',
      leituraMedida: '{sessoes} · {rejeicao}%',
      maior: 'A de maior rejeição com 20+ sessões fica em {pct}%.'
    },
    vazio: 'Nenhuma página nesta execução.',
    naoMedido:
      'Esta execução não mediu busca e tráfego. Conecte o Google Analytics e o Search Console ao projeto — execuções futuras passam a trazer o cruzamento.',
    conectar: 'Configurar integrações',
    casamento: 'Casamento',
    casamentoNota: '{casadas} de {total} páginas rastreadas têm dado do Google',
    completude: 'Completude',
    completudeNota: '{casadas} de {total} URLs do Google foram rastreadas.',
    orfasEm: 'As outras {n} estão em Técnico.',
    cliques: 'Cliques',
    impressoes: 'Impressões',
    sessoes: 'Sessões',
    usuarios: 'Usuários',
    engajadas: 'Engajadas',
    somadosPorEntrada: 'somados por página de entrada',
    conversoes: 'Conversões',
    porEntrada: 'por página de entrada',
    porEvento: 'na página do evento',
    posicao: 'Posição',
    posicaoMedia: 'Posição média',
    pagina: 'Página',
    paginasTitulo: 'Desempenho por página',
    tabelaNota: 'Na ordem do funil: aparece, clica, fica, converte.',
    tabelaLink: 'Para filtrar e exportar, use a aba Páginas.',
    porDia: {
      titulo: 'Cliques e sessões por dia',
      nota: 'O site inteiro, dia a dia. Passe o mouse ou toque numa barra para ler o dia.',
      serie: '{serie} · {total} no período · pico de {pico} em {dia}',
      dia: 'Dia'
    },
    porCanal: {
      titulo: 'Sessões por canal',
      nota: '{total} sessões no site inteiro, cada uma contada uma vez, pela origem que o GA4 atribuiu. As Sessões acima somam as páginas: lá, quem vê três páginas conta três vezes.'
    },
    /* Os nomes que o GA4 dá aos canais, como o próprio GA4 os traduz. */
    canal: {
      'Organic Search': 'Busca orgânica',
      'Paid Search': 'Busca paga',
      Direct: 'Direto',
      'Cross-network': 'Rede cruzada',
      'Organic Shopping': 'Shopping orgânico',
      'Paid Shopping': 'Shopping pago',
      'Organic Social': 'Social orgânico',
      'Paid Social': 'Social pago',
      'Organic Video': 'Vídeo orgânico',
      'Paid Video': 'Vídeo pago',
      'Paid Other': 'Outros pagos',
      Display: 'Display',
      Referral: 'Referência',
      Email: 'E-mail',
      Affiliates: 'Afiliados',
      SMS: 'SMS',
      Audio: 'Áudio',
      'Mobile Push Notifications': 'Notificações push',
      'AI Assistant': 'Assistente de IA',
      Unassigned: 'Não atribuído'
    },
    orfasTitulo: '{n} URLs que o Google conhece e o rastreamento não visitou',
    orfasNota: '{verificadas} verificadas por requisição HTTP; {faltam} aguardam verificação.',
    recuperacaoTitulo: 'Uma regra pode trazer parte de volta',
    recuperacaoMedida:
      'Testada em {testadas} URLs, funcionou em {recuperadas} ({acerto}%). Estimativa: {estimadas} das {afetadas} afetadas voltariam.',
    recuperacaoParcial:
      'Não aplique a regra sem conferir o destino: a parcela que não recupera cairia na mesma página de erro que se quer eliminar. O redirect precisa devolver 404 para o que não existir.',
    classe: { soft404: 'soft 404', morta: 'morta', redirecionada: 'redirecionada', viva: 'viva', bloqueada_robots: 'bloqueada pelo robots' },
    acao: { soft404: 'Respondem 200 com página de erro. Redirecionar para o equivalente ou devolver 404/410.', morta: 'Comportamento correto: o Google as remove com o tempo. Redirecionar com 301 só se houver equivalente.', redirecionada: 'Atualizar links internos e sitemap para o destino final.', viva: 'Funcionam e o crawler não chegou nelas: falta link interno ou o teto de páginas cortou.', bloqueada_robots: 'O robots.txt fecha essa área e não as verificamos: conferir se o bloqueio é intencional.' },
    orfasNotaTodas: 'Todas as {verificadas} verificadas por requisição HTTP.',
    col: { estado: 'Estado', urls: 'URLs', fazer: 'O que fazer' }
  },

  social: {
    titulo: 'Redes sociais',
    resumo: '{sessoes} sessões · {conversoes}',
    conversoes: { um: '{n} conversão', outros: '{n} conversões' },
    naoColetado:
      'Esta execução não leu o tráfego das redes sociais. Execuções sem Google Analytics, ou feitas antes desta medição, não têm o dado.',
    vazio: 'Nenhuma visita vinda de redes sociais no período.',
    organico: 'Orgânico',
    pago: 'Pago',
    nota: 'Segundo a classificação de canais do Google Analytics. Link aberto pelo WhatsApp muitas vezes chega sem origem e aparece como tráfego direto, não social.',
    col: {
      rede: 'Rede',
      canal: 'Tipo',
      sessoes: 'Sessões',
      engajamento: 'Engajadas',
      conversoes: 'Conversões',
      paginas: 'Páginas de entrada'
    }
  },

  serp: {
    titulo: 'Quem aparece com você',
    intro: 'Domínios no top 10 do celular, entre os {n} termos medidos',
    naoMedido:
      'Esta execução não leu a página do Google. A leitura precisa do Search Console conectado e do volume de busca.',
    falhou: 'não veio',
    foraDoTopo: 'fora do top 10',
    bloco: {
      paid: 'Anúncios',
      ai_overview: 'AI Overview',
      featured_snippet: 'Trecho em destaque',
      answer_box: 'Resposta direta',
      popular_products: 'Produtos',
      shopping: 'Shopping',
      local_pack: 'Mapa com empresas',
      map: 'Mapa',
      people_also_ask: 'Perguntas relacionadas',
      images: 'Imagens',
      video: 'Vídeos',
      short_videos: 'Vídeos curtos',
      top_stories: 'Notícias',
      knowledge_graph: 'Painel de conhecimento',
      discussions_and_forums: 'Fóruns'
    },
    nota: 'A barra conta em quantos dos {n} termos o domínio aparece no top 10. É o retrato do dia da execução; a posição e os blocos de cada termo estão na tabela de cima.',
    acima: '{bloco} aparece acima do site em {n} dos {m} termos em que ele está no top 10.',
    acimaUm: '{bloco} aparece acima do site no único termo em que ele está no top 10.',
    semConcorrentes: 'Nenhum domínio no top 10 desses termos.'
  },
  comparacao: {
    titulo: 'Desde a execução anterior',
    intro: 'Contra a execução {nome}, de {data}, nas {n} páginas que as duas mediram.',
    introRerun: 'Re-run da execução {nome}, de {data}: as mesmas {n} páginas, medidas de novo.',
    foraDaConta: '{atual} páginas só nesta execução e {base} só na anterior ficam fora da conta.',
    corte:
      'Uma das duas parou no limite de páginas: a comparação vale para as páginas em comum, não para o site inteiro.',
    semBase: 'Ainda não há execução anterior concluída deste projeto para comparar.',
    semMudanca: 'Nenhum problema mudou nas páginas em comum.',
    col: { problema: 'Problema', corrigidas: 'Corrigidas', novas: 'Novas' },
    nota:
      'Uma página conta como corrigida quando tinha o problema na anterior e não tem nesta, e como nova no caso inverso. Os filtros da tela não se aplicam aqui. Sites que mudam o conteúdo a cada acesso podem aparecer com mudanças sem que nada tenha sido alterado.'
  },
  tendencias: {
    titulo: 'Tendências',
    naoMedido:
      'Esta execução não comparou os termos. Execuções sem Search Console, ou feitas antes desta medição, não têm o dado.',
    emAlta: 'Em alta',
    novos: 'Novos',
    emQueda: 'Em queda',
    vazio: 'Nenhum termo.',
    nota: 'Só entram termos com pelo menos 30 impressões em uma das duas janelas. O Google omite buscas raras, então um termo novo pode já ter existido abaixo desse limite. Quando o site inteiro cresce, quase todo termo sobe junto: compare cada variação com a do total.',
    sub: 'Impressões nesta janela, contra os 28 dias anteriores'
  },

  velocidade: {
    titulo: 'Velocidade das páginas',
    naoMedido:
      'Esta execução não mediu a velocidade das páginas. Execuções feitas antes desta medição não têm o dado.',
    medindo:
      'Medindo a velocidade das páginas principais no Google. Leva alguns minutos depois do fim do rastreamento, e esta seção se atualiza sozinha.',
    medindoCsv:
      'A velocidade ainda está sendo medida no Google. O CSV baixado agora sai sem PageSpeed, LCP, INP e CLS; em alguns minutos este aviso some e o arquivo sai completo.',
    naoMedida: 'O Google não conseguiu medir esta página.',
    tom: {
      bom: 'bom',
      medio: 'precisa melhorar',
      ruim: 'ruim'
    },
    nota: 'Notas: abaixo de 50 é ruim, de 50 a 89 precisa melhorar, 90 ou mais é bom. "domínio": a página não tem visitas suficientes para ter dado de campo próprio, e vale o do cartão acima.',
    col: {
      pagina: 'Página',
      nota: 'Nota',
      lcp: 'LCP',
      inp: 'INP',
      cls: 'CLS',
      resposta: 'Resposta do HTML',
      peso: 'Peso do HTML'
    },
    fontes: 'Crawler: todas as páginas, no momento da execução · PageSpeed: {n} páginas com mais visita, celular',
    frase: { lab: 'O laboratório dá {media}.', labHtmlRapido: 'O laboratório dá {media}, e o HTML não é o que pesa.', labHtmlLento: 'O laboratório dá {media}, e o HTML demora {ms} ms em média.' },
    rotulo: { resposta: 'Resposta do HTML', lab: 'Nota de laboratório', campo: '{m} · campo' },
    notaResposta: 'média de {n} páginas · crawler',
    mediaDe: 'média de {n} páginas',
    limiteDe: 'limite {valor}',
    dominio: { titulo: 'Core Web Vitals do domínio', sub: 'Visitantes reais do Chrome, 28 dias. {k} das {n} páginas não têm dado próprio e recebem o do domínio.', subTodas: 'Visitantes reais do Chrome, 28 dias.', lcp: 'LCP · maior elemento visível', inp: 'INP · resposta a clique e toque', cls: 'CLS · deslocamento do layout', regua: '{m} {valor}, na faixa {faixa}; o limite do bom é {limite}', propria: '{pagina} tem dado próprio: LCP {lcp}, INP {inp}, CLS {cls}.', home: 'A home' },
    html: { titulo: 'Tempo de resposta do HTML', sub: 'Medido pelo crawler nas {n} páginas.', leituraTitulo: 'Leitura cruzada', leitura: '{a} responde em {msA} e tira {notaA}. {b} responde em {msB} e tira {notaB}. A nota baixa vem do que carrega depois do HTML: scripts, imagens, fontes.' },
    tabela: { titulo: 'As {n} páginas medidas', sub: 'Nota de laboratório, mediana de 3 medições; a de uma página varia cerca de 10 pontos entre execuções, a média do site não. Resposta e peso vêm do crawler.', dominio: 'domínio' }
  },
  termosPrincipais: {
    titulo: 'Termos principais, uma linha cada',
    intro:
      'Os {n} termos com mais impressões no Brasil, com o que o Search Console mediu, a posição no celular durante a execução e a procura no Google Ads.',
    grupo: {
      gsc: 'Search Console · 28 dias',
      serp: 'Celular · na execução',
      ads: 'Google Ads'
    },
    col: {
      termo: 'Termo',
      impressoes: 'Impressões',
      variacao: 'Variação',
      cliques: 'Cliques',
      posicao: 'Posição',
      celular: 'Celular hoje',
      volume: 'Buscas/mês',
      captura: 'Captura',
      meses: '12 meses',
      cpc: 'CPC (US$)'
    },
    blocos: { um: '{n} bloco acima', outros: '{n} blocos acima' },
    serie: '12 meses: de {de} para {ate} buscas por mês',
    concorrencia: {
      LOW: 'baixa',
      MEDIUM: 'média',
      HIGH: 'alta'
    },
    nota:
      'Variação de impressões contra os 28 dias anteriores; compare com a do site inteiro em Tendências. A posição do Search Console é a média de 28 dias e de todos os dispositivos; "Celular hoje" é o retrato de uma busca no momento da execução. CPC e concorrência do Google Ads, pela DataForSEO.'
  },
  historico: {
    titulo: 'Entre execuções',
    col: {
      execucao: 'Execução',
      nota: 'Nota',
      cliques: 'Cliques'
    }
  },

  termos: {
    titulo: 'Termos de busca',
    intro:
      'Para quais buscas cada página aparece: um par de página e termo por linha.',
    naoColetado:
      'Esta execução não coletou termos de busca. Execuções feitas antes desta medição não têm o dado.',
    truncado:
      'A coleta atingiu o teto por execução. Estes são os termos mais clicados, não todos — o restante ficou de fora.',
    recorte: 'Recorte da lista',
    recorteAtaque: 'Em distância de ataque',
    recorteTodos: 'Todos',
    mostrando: 'Mostrando {n} termos em distância de ataque, de {total} no total.',
    vazio: 'Nenhum termo de busca nesta execução.',
    vazioAtaque:
      'Nenhum termo em distância de ataque nesta execução. Escolha “Todos” para ver a lista completa.',
    anonimizacao:
      'O Google não informa consultas de baixo volume. Por isso a soma das impressões por termo é sempre menor que o total da página — não é falha da coleta.',
    volumeNota:
      'Buscas no Brasil em {mes}, nas faixas arredondadas do Google Ads (via DataForSEO). Captura é a parte dessas buscas em que o site apareceu: impressões no Brasil ÷ buscas do mês. Travessão quer dizer que o Google não tem o dado ou que o termo teve menos de 10 impressões.',
    col: {
      termo: 'Termo',
      pagina: 'Página',
      impressoes: 'Impressões',
      cliques: 'Cliques',
      ctr: 'CTR',
      posicao: 'Posição',
      volume: 'Buscas/mês',
      captura: 'Captura'
    }
  },

  botsIa: {
    titulo: 'Bots de IA no robots.txt',
    intro:
      'O que o robots.txt do site permite aos buscadores de IA. Um site pode estar impecável e mesmo assim estar fechado para eles.',
    indisponivel:
      'Não foi possível ler o robots.txt do site nesta execução. Sem ele não dá para afirmar o que está liberado.',
    erro: 'Esta execução não verificou o robots.txt.',
    aviso: '{n} rastreador(es) de IA sem acesso ao site: {nomes}.',
    resposta: 'Leem para responder agora',
    treino: 'Leem para treinar modelo',
    semJuizo:
      'Bloquear pode ser a decisão certa — não recomendamos nada aqui, só mostramos o estado. O que não convém é o bloqueio existir sem que ninguém saiba.',
    estado: {
      livre: 'Liberado',
      restrito: 'Parcial',
      bloqueado: 'Bloqueado'
    },
    contagem: { restrito: { um: '{n} parcial', outros: '{n} parciais' }, bloqueado: { um: '{n} bloqueado', outros: '{n} bloqueados' } },
    todosLivres: 'todos liberados'
  },

  docs: {
    titulo: 'Documentação',
    chamada: 'Como o Silent Puma funciona, descrito a partir do que o produto faz de verdade.',
    indice: 'Seções',

    comecarTitulo: 'Primeiros passos',
    comecarA:
      'Um projeto é um site ou um canal do YouTube. Dentro dele, cada execução é um rastreamento: um retrato daquele site naquele dia. Você pode ter {projetos} projeto(s) no plano {plano}.',
    comecarB:
      'A ordem é sempre a mesma — criar o projeto, configurar a execução, esperar terminar e então ler o painel. Nada é analisado antes de a execução concluir, porque um rastreamento pela metade produz um retrato pela metade, e não há como saber qual metade ficou de fora.',

    rastreamentoTitulo: 'Configurar um rastreamento',
    rastreamentoA:
      'O comportamento decide até onde o rastreador vai: seguir todo link do domínio, ficar abaixo do caminho inicial, ou incluir subdomínios. Os subdomínios contam na mesma cota de páginas, então é a opção que mais mexe no seu consumo.',
    rastreamentoB:
      'Os parâmetros de URL são o outro ajuste que move o número. Mantê-los faz cada combinação de filtro virar uma página — numa loja com cor e tamanho, um produto sozinho consome dezenas. Descartá-los rastreia cada página uma vez.',
    rastreamentoC:
      'Antes de começar, use "Estimar páginas correspondentes". Ele lê o sitemap do site e mostra quantos endereços casam com os seus filtros, com exemplos. Os exemplos são o ponto: é neles que você percebe que "/p" trouxe junto a política de privacidade.',

    painelTitulo: 'Ler o painel',
    painelA:
      'O painel se divide em cinco áreas, na ordem em que o problema importa: indexação, conteúdo, experiência, mídia e links. Se o rastreador não chega à página, nada mais sobre ela importa — por isso indexação vem primeiro.',
    painelB:
      'O número em cada aba é quantas páginas têm problema naquela área, não quantos problemas existem. Uma página sem título e sem H1 conta uma vez. A aba com um visto quer dizer que ali não há o que corrigir, então dá para pular sem abrir.',
    painelC:
      'Os títulos são medidos contra {tituloMin}–{tituloMax} caracteres e as descrições contra {metaMin}–{metaMax}. O Google não publica tamanho oficial; essas são as faixas que costumam aparecer sem corte. Tempo de resposta acima de {lenta}s é marcado como lento — medimos resposta do servidor, não Largest Contentful Paint.',

    iaTitulo: 'Análise de IA',
    iaA: 'A IA lê os dados do rastreamento e devolve uma lista priorizada de correções, cada uma mostrando quantas páginas ela afeta. Ela nunca roda sozinha: gerar custa crédito, então só acontece quando você pede. Seu plano inclui {creditos} créditos por mês.',
    iaB: 'A análise padrão custa um crédito e a profunda custa dois. A profunda gasta mais raciocínio em sites complexos; numa checagem de rotina a diferença raramente aparece. O campo de foco é o controle que vale usar — é você quem sabe que o blog não importa, ou que o catálogo é a prioridade.',
    iaC: 'Cada geração vira uma versão, então dá para comparar duas configurações sem pagar duas vezes. A análise é escrita no idioma da sua conta, definido no seu perfil.',

    conectorTitulo: 'Conector para a sua IA',
    conectorA:
      'O conector abre os dados dos seus rastreamentos dentro da IA que você já usa — Claude, ChatGPT ou Cursor. Em vez de ler o relatório aqui, você pergunta lá, com o modelo e o contexto que já são seus.',
    conectorB:
      'Por padrão ele só lê, e ler não consome crédito nem cota, porque a inteligência é a sua. Se você quiser, em Configurações dá para permitir que a IA peça rastreamentos: cada um consome a cota de páginas do seu plano, com um teto por dia e um de cada vez por projeto. Mesmo assim, nenhuma ferramenta cria projeto, apaga execução, gera análise ou altera a sua conta.',
    conectorC:
      'Perguntas que ele responde bem: quais páginas têm link quebrado, para quais termos cada página aparece, o que a última análise recomendou priorizar, quanto do seu plano você já usou, e quais vídeos do canal têm mais visualizações.',
    conectorD:
      'Quando publicamos ferramentas novas, elas não aparecem sozinhas: a sua IA guarda a lista de quando você conectou. Remova e adicione o conector de novo para vê-las.',
    conectorPasso1: 'Copie o endereço acima.',
    conectorPasso2:
      'Na sua IA, abra as configurações de conectores e escolha adicionar um conector personalizado. Em alguns aplicativos a opção aparece como "MCP".',
    conectorPasso3:
      'Cole o endereço e confirme. Você será trazido de volta ao Silent Puma para entrar com a sua conta e autorizar o acesso.',
    conectorPasso4:
      'Pronto. Volte para a conversa e pergunte sobre os seus projetos — a IA vai buscar os dados sozinha quando precisar.',

    relatorioTitulo: 'O relatório em PDF',
    relatorioA:
      'Toda execução concluída pode virar um relatório de auditoria técnica, feito para entregar ao cliente. Ele abre como página e imprime pelo navegador, o que produz texto vetorial de verdade — pesquisável e nítido em qualquer ampliação, diferente de uma exportação em imagem.',
    relatorioB:
      'O relatório traz um score de SEO de 0 a 100. Ele parte de 100 e perde uma parcela do peso de cada área na proporção das páginas afetadas: indexação 25, conteúdo 30, experiência 20, links 15, mídia 10. Uma página com três problemas na mesma área conta uma vez — é uma página a corrigir, não três.',
    relatorioC:
      'Quando existe análise de IA, o relatório abre com o resumo e as prioridades dela. Sem ela o relatório sai do mesmo jeito, só que sem essas duas seções.',

    repetirTitulo: 'Repetir uma execução',
    repetirA:
      'Duas execuções do mesmo site raramente cobrem as mesmas páginas: cada uma descobre endereços a partir da URL inicial, então um link que apareceu nesta semana muda a amostra. Comparar score entre amostras diferentes mede a amostra, não o site.',
    repetirB:
      '"Repetir", na lista de execuções, rastreia exatamente as páginas que a execução anterior coletou. É isso que faz a diferença de score significar alguma coisa — e o relatório diz em qual das duas situações você está.',

    planosTitulo: 'Planos e limites',
    planosA:
      'Seu plano define três coisas: quantos projetos você pode ter ({projetos}), quantas páginas pode rastrear por mês ({paginas}) e por quanto tempo os dados coletados ficam guardados ({retencao} dias). O mês reinicia na sua data de cobrança.',
    planosB:
      'Páginas que responderam com status de sucesso mas não entregaram conteúdo útil não contam na cota. Você não recebeu dado nenhum delas, e ainda vai ter o trabalho de descobrir por quê — cobrar cota por cima disso seria cobrar por algo que não foi entregue.',

    dadosTitulo: 'Seus dados',
    dadosA:
      'O rastreamento coleta o que a página publica: endereço, status, título, descrição, títulos internos, links e contagem de imagens. Nada atrás de login, e nenhuma página que o site pede para não ser indexada.',
    dadosB:
      'Quando você pede uma análise de IA, métricas agregadas e uma amostra de endereços vão para o provedor de IA — nunca os dados da sua conta nem suas credenciais. A política de privacidade descreve campo a campo.',

    duvidaTitulo: 'Ainda travado?',
    duvidaTexto:
      'Escreva para {email} contando o que você estava fazendo e o que esperava. Mencionar o número da execução ajuda — é o que nos deixa olhar exatamente o dado que você estava olhando.'
  },

  blog: {
    eyebrow: 'Blog',
    titulo: 'O que medimos, e o que os números querem dizer',
    chamada:
      'Notas técnicas de quem roda crawler todo dia. Cada post traz o método, para você conferir em vez de acreditar.',
    buscar: 'Buscar no blog',
    emDestaque: 'Em destaque',
    todosOsPosts: 'Todos os posts',
    publicados: { um: '{n} PUBLICADO', outros: '{n} PUBLICADOS' },
    minutos: { um: '{n} min de leitura', outros: '{n} min de leitura' },
    semPosts: 'Nada publicado ainda. As primeiras notas estão sendo escritas.',
    semResultado: 'Nenhum post corresponde a esta busca.',
    voltar: '← Voltar para o blog',
    nestePost: 'Neste post',
    leiaTambem: 'Leia também',
    catProduto: 'Produto',
    catMetodo: 'Método',
    catYoutube: 'YouTube'
  },

  erros: {
    oportunidades: 'Não foi possível carregar as oportunidades.',
    desempenhoCanal: 'Não foi possível carregar o desempenho do canal.',
    perfil: 'Não foi possível salvar seu perfil.',
    empresa: 'Não foi possível salvar os dados da empresa.',
    convite: 'Não foi possível enviar o convite.',
    equipe: 'Não foi possível alterar a equipe.',
    foto: 'Erro ao atualizar a foto de perfil.',
    uso: 'Erro ao carregar os dados de uso',
    checkout: 'Erro ao criar a sessão de pagamento',
    compra: 'Não foi possível iniciar a compra.',
    cancelamento: 'Erro ao cancelar a assinatura.',
    exclusao: 'Erro ao apagar a conta.',
    mensagem: 'Erro ao enviar a mensagem',
    planoIndisponivel: 'Este plano não está disponível para compra no momento.',
    integracao: 'Não foi possível iniciar a integração.',
    integracaoRecursos: 'Não foi possível listar as propriedades da conta conectada',
    projetos: 'Erro ao carregar projetos',
    apagarProjeto: 'Erro ao apagar o projeto',
    baixar: 'Erro ao baixar os resultados',
    acessoNegado: 'Acesso negado a este projeto',
    carregarProjeto: 'Erro ao carregar o projeto',
    carregarExecucoes: 'Erro ao carregar as execuções',
    trafego: 'Erro ao carregar busca e tráfego',


    termos: 'Erro ao carregar os termos de busca',
    social: 'Erro ao carregar o tráfego das redes sociais',
    velocidade: 'Erro ao carregar a velocidade das páginas',
    tendencias: 'Erro ao carregar os termos em alta',
    comparacao: 'Erro ao carregar a comparação com a execução anterior',
    serp: 'Erro ao carregar a página do Google',
    execucao: 'Erro ao carregar a execução',
    repetir: 'Não foi possível repetir a execução.',
    apagarExecucao: 'Erro ao apagar a execução',
    pararExecucao: 'Não foi possível parar a execução.',
    login: 'Falha na entrada. Confira seus dados.',
    loginFalha: 'Erro ao entrar. Tente de novo mais tarde.',
    conexao: 'Erro de conexão. Tente de novo.',
    emailUsado: 'E-mail já cadastrado',
    cadastro: 'Erro ao processar a solicitação.',
    recuperacao: 'Não foi possível processar a solicitação.',
    atualizarSenha: 'Não foi possível atualizar a senha.',
    concluirCadastro: 'Erro ao concluir o cadastro.',
    plano: 'Este plano não está disponível agora.',
    requisicao: 'Erro ao processar a requisição.',
    generico: 'Algo deu errado. Tente de novo mais tarde.',
    cancelamentoAssinatura: 'Não foi possível cancelar a assinatura.',
    historico: 'Erro ao carregar o histórico de cobranças',
    configuracao: 'Erro ao carregar a configuração.',
    criarProjeto: 'Erro ao criar o projeto.',
    criarProjetoTentar: 'Erro ao criar o projeto. Tente de novo.',
    nomeDaRun: 'Informe um nome para a execução.',
    semItens: 'Você tem apenas {n} itens disponíveis no plano {plano}.',
    iniciarCrawler: 'Erro ao iniciar o rastreamento.',
    servidorInacessivel: 'Não foi possível falar com o servidor.',
    enviar: 'Não foi possível enviar. Tente de novo.',
    execucoes: 'Erro ao carregar as execuções',
    dados: 'Erro ao carregar os dados',
    otimizacoes: 'Não foi possível gerar as otimizações.',
    projeto: 'Não foi possível carregar este projeto.',
    execucoesDoProjeto: 'Não foi possível carregar as execuções deste projeto.',
    paginasColetadas: 'Não foi possível carregar as páginas coletadas.'
  },

  /* Área logada nova (NewAppShell e as telas New*). */
  area: {
    navegacao: 'Navegação principal',
    caminho: 'Caminho',
    de: 'de {total}',
    semLimite: 'sem limite',
    limiteDoPlano: 'limite de {total} no plano',
    creditosRestantes: '{restantes} de {total} créditos de IA disponíveis',
    creditosDoMes: 'Do mês: {mes}',
    creditosOrigem: 'Do mês: {mes} · Comprados: {extra}',
    creditosCurto: 'créditos',
    privacidade: 'Privacidade',
    termos: 'Termos',
    hoje: 'hoje',
    ontem: 'ontem',
    dias: { um: 'há {n} dia', outros: 'há {n} dias' },
    meses: { um: 'há {n} mês', outros: 'há {n} meses' },
    anos: { um: 'há {n} ano', outros: 'há {n} anos' },
    painel: {
      resumo: 'Resumo da conta',
      ultima: 'Última execução: #{id}, em {projeto}, {situacao}.',
      situacao: {
        completed: 'iniciada {quando}',
        in_progress: 'em andamento',
        pending: 'na fila',
        error: 'falhou',
        cancelled: 'cancelada'
      },
      paginasEVideos: 'Páginas e vídeos',
      paginasDetalhe: '{sites} de sites · {videos} do YouTube',
      atalhos: 'Atalhos',
      atalhoDocsTexto: 'Como a nota é calculada e como configurar um rastreio.'
    },
    integracoes: 'Integrações',
    intervalo: '{de}–{ate} de {total}',
    projetos: {
      tipo: 'Tipo',
      itens: 'Páginas ou vídeos',
      ultima: 'Última execução',
      paginas: { um: 'página', outros: 'páginas' },
      videos: { um: 'vídeo', outros: 'vídeos' },
      execucoes: { um: 'execução', outros: 'execuções' },
      semResultado: 'Nenhum projeto com esse nome neste filtro.'
    },
    criar: {
      tipoTexto: 'Decide o endereço pedido abaixo e o que a execução coleta: páginas ou vídeos.',
      nomeTexto: 'Para achar o projeto na lista e no painel.'
    },
    sim: 'Sim',
    nao: 'Não',
    conta: {
      usoEm: 'Uso, créditos e troca de plano ficam em',
      perfilTexto: 'Nome e foto aparecem no menu. O e-mail é o do login.',
      trocarFoto: 'Trocar foto',
      idiomaNaHora: 'Muda na hora e fica salvo na conta.'
    },
    plano: {
      uso: 'Uso da conta',
      recurso: 'Recurso',
      seuPlano: 'seu plano',
      linhas: {
        preco: 'Preço',
        projetos: 'Projetos',
        paginas: 'Páginas por mês',
        creditos: 'Créditos de IA por mês',
        painel: 'Painel do site e do canal',
        conector: 'Conector MCP para a sua IA',
        integracoes: 'Analytics, Search Console e YouTube Analytics',
        suporte: 'Suporte',
        retencao: 'Retenção de dados'
      },
      dias: { um: '{n} dia', outros: '{n} dias' },
      ultimaRenovacao: 'Créditos do mês renovados em {data}',
      ultimaCobranca: 'Última cobrança',
      cobrancaFalhou: 'Esta cobrança não passou. O histórico mostra todas as cobranças.',
      mensagemBusiness: 'Tenho interesse no plano Business.'
    },
    pagamentos: {
      verRecibo: 'Ver recibo',
      semRecibo: 'Sem recibo'
    },
    abas: {
      rotulo: 'Páginas do projeto',
      painel: 'Painel',
      visao: 'Visão geral',
      trafego: 'Busca e tráfego',
      termos: 'Palavras-chave',
      tecnico: 'Técnico',
      velocidade: 'Velocidade',
      paginas: 'Páginas'
    },
    palavras: {
      fonte: { gsc: 'Search Console, consultas no Brasil · {periodo}', volume: 'volume Google Ads de {mes}', serp: 'SERP no celular em {data}' },
      rotulo: { termos: 'Termos com impressão', ataque: 'Em distância de ataque', celular: 'No top 10 do celular', impressoes: 'Impressões no Brasil' },
      nota: { termos: 'pares página × termo', celular: 'os {n} termos com mais impressões', impressoes: '{antes} → {agora}, contra os 28 dias anteriores' },
      de: 'de {n}'
    },
    visao: {
      ctrPosicao: 'CTR {ctr}% · posição {posicao}',
      conversoes: { um: '{n} conversão', outros: '{n} conversões' },
      ataque: 'posição 5 a 20, com demanda',
      velocidade: 'Nota de velocidade',
      naoMedido: 'não medido nesta execução',
      rotulo: { cliques: 'Cliques do Google', ataque: 'Termos em ataque', cwv: 'Core Web Vitals' },
      critico: 'crítico',
      nenhum: 'nenhum',
      tipos: { um: 'em {n} tipo de problema', outros: 'em {n} tipos de problema' },
      engajadas: '{pct}% engajadas',
      de3: 'de 3 bons',
      cwvNota: 'LCP {lcp} · INP {inp}',
      contexto: 'Run #{id} · {data}',
      google: 'Google: {periodo}',
      frase: {
        paginas: '{n} páginas, {erro} com erro.',
        google: 'No Google, {impressoes} impressões viraram {cliques} cliques.',
        cwvTodos: 'Visitantes reais passam nos três Core Web Vitals.',
        cwvParte: 'Visitantes reais passam em {n} de 3 Core Web Vitals.'
      },
      blocos: { um: '{n} bloco', outros: '{n} blocos' },
      achados: { titulo: 'Um achado de cada aba', sub: 'o maior de cada assunto nesta run' },
      achado: {
        termo: '"{termo}" tem {volume} buscas por mês e o site captura {captura}%.',
        celularPosicao: ' No celular, está em {pos}º, com {blocos} acima.',
        celularFora: ' No celular, está fora do top 10, com {blocos} na página.',
        pagina: '{pagina} aparece {impressoes} vezes na posição {posicao} e recebe {cliques} cliques (CTR {ctr}%).',
        orfas: '{soft} URLs que o Google ainda conhece respondem como soft 404, e {mortas} estão mortas.',
        velocidade: '{pagina} tem nota {nota} no laboratório, a menor das {n} medidas.',
        problema: 'O problema crítico mais frequente é "{problema}", em {n} páginas.'
      },
      acao: { termo: 'Ver termo', pagina: 'Ver página', urls: 'Ver URLs', lista: 'Abrir lista' },
      fontes: {
        titulo: 'Fontes desta run',
        crawler: 'Crawler',
        gsc: 'Search Console',
        ga: 'Analytics',
        psi: 'PageSpeed',
        dfs: 'DataForSEO',
        robots: 'robots.txt',
        paginas: '{n} páginas',
        psiDetalhe: '{n} páginas, celular',
        volume: 'volume de {mes}',
        bots: '{n} bots de IA',
        lido: 'lido',
        naoMedido: 'não medido',
        falhou: 'falhou'
      },
      corrigidas: { um: '{n} corrigida', outros: '{n} corrigidas' },
      novas: { um: '{n} nova', outros: '{n} novas' },
      saldo: 'Contra a #{base}, só URLs em comum: {corrigidas} e {novas}.',
      detalhe: 'Detalhe no Técnico'
    },
    conjuntos: {
      rotulo: 'Conjunto de colunas',
      essencial: 'Essencial',
      tecnico: 'Técnico',
      trafego: 'Tráfego',
      conteudo: 'Conteúdo',
      produto: 'Produto',
      oQueMostra: 'O que cada conjunto mostra'
    },
    runs: {
      repeteA: 'repete a #{n}'
    },
    nova: {
      titulo: 'Nova execução',
      filtros: 'Filtros de URL',
      filtrosTexto: 'Para rastrear só uma parte do site. As exclusões ganham do filtro de inclusão.'
    },
    site: {
      indice: 'Nesta página',
      resumo: 'Resumo',
      tecnico: 'Técnico',
      recorte: 'Valem para Técnico e Páginas. As outras abas mostram a execução inteira.',
      criticos: 'Ocorrências críticas',
      avisos: 'Avisos',
      cargaMedia: 'Média de {ms} ms nas {n} páginas rastreadas.',
      links: {
        titulo: 'Links quebrados',
        com: 'Páginas com link quebrado',
        proprios: 'Com link próprio quebrado',
        template:
          'Nenhuma página tem link próprio quebrado: é o mesmo link do layout, repetido em todas. Corrigir o template resolve as {n}.',
        proprio: 'Para saber quais páginas têm link próprio quebrado, use a coluna "Links quebrados (próprios)" em Páginas.'
      },
      carga: 'Resposta do HTML (ms)',
      dasPaginas: '{pct}% das páginas',
      paginas: { um: '{n} página', outros: '{n} páginas' },
      aviso: 'aviso',
      profundidadeMax: 'profundidade máxima {n}',
      de: '{a} de {b}',
      problemas: { titulo: 'Problemas', nota: 'Gravidade primeiro, depois quantidade. Clicar abre Páginas já filtrada pelo problema.', escala: 'barra = % das {n} páginas' },
      cartao: { metadados: 'Metadados', acesso: 'Acessibilidade e links', profundidade: 'Cliques a partir da home', status: 'Status HTTP' },
      paginasSub: 'Mesmo recorte do Técnico. O CSV sai com os filtros, todas as colunas e os problemas de cada página.',
      problema: 'Problema',
      semProblema: 'Nenhum filtro'
    },
    run: {
      numeros: 'Números da execução'
    },
    otim: {
      caminho: 'Otimizações',
      profundidade: 'Profundidade'
    },
    yt: {
      graficos: 'Gráficos',
      recorte: 'Valem para o resumo, os gráficos e a tabela. Desempenho do canal mostra a execução inteira.'
    }
  }
};

export default pt;
